export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type ActionModel = {
  __typename?: 'ActionModel';
  assignList: Maybe<Array<Maybe<AssignModel>>>;
  bannerType: Maybe<Scalars['Int']>;
  bannerURL: Maybe<Scalars['String']>;
  defaultAssign: Maybe<Scalars['Boolean']>;
  enabled: Maybe<Scalars['Boolean']>;
  filterList: Maybe<Array<Maybe<FilterModel>>>;
  from: Maybe<Scalars['String']>;
  giftList: Maybe<Array<Maybe<GiftModel>>>;
  giftType: Maybe<Scalars['Int']>;
  hasFilter: Maybe<Scalars['Boolean']>;
  hasLimit: Maybe<Scalars['Boolean']>;
  hasLimitWarning: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['Int']>;
  idBody: Maybe<Scalars['Int']>;
  isCopy: Maybe<Scalars['Boolean']>;
  language: Maybe<Scalars['String']>;
  limit: Maybe<Scalars['Int']>;
  limitWarning: Maybe<Scalars['Int']>;
  limitWarningEmails: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  showAction: Maybe<Scalars['Boolean']>;
  showBannerType: Maybe<Scalars['Boolean']>;
  showOnDetailPage: Maybe<Scalars['Boolean']>;
  text: Maybe<Scalars['String']>;
  to: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ActionModelInput = {
  assignList?: InputMaybe<Array<InputMaybe<AssignModelInput>>>;
  bannerType?: InputMaybe<Scalars['Int']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  defaultAssign?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  filterList?: InputMaybe<Array<InputMaybe<FilterModelInput>>>;
  from?: InputMaybe<Scalars['String']>;
  giftList?: InputMaybe<Array<InputMaybe<GiftModelInput>>>;
  giftType?: InputMaybe<Scalars['Int']>;
  hasFilter?: InputMaybe<Scalars['Boolean']>;
  hasLimit?: InputMaybe<Scalars['Boolean']>;
  hasLimitWarning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  idBody?: InputMaybe<Scalars['Int']>;
  isCopy?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  limitWarning?: InputMaybe<Scalars['Int']>;
  limitWarningEmails?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  showAction?: InputMaybe<Scalars['Boolean']>;
  showBannerType?: InputMaybe<Scalars['Boolean']>;
  showOnDetailPage?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ActionTypesModel = {
  __typename?: 'ActionTypesModel';
  bannerTypeList: Maybe<Array<Maybe<BannerTypeModel>>>;
  giftTypeList: Maybe<Array<Maybe<GiftTypeModel>>>;
};

export type ActualProduct = {
  __typename?: 'ActualProduct';
  id: Scalars['String'];
};

export type AddGiftToCart = {
  __typename?: 'AddGiftToCart';
  itemId: Scalars['Int'];
};

export type AddProductResponse = {
  __typename?: 'AddProductResponse';
  productAddResponse: Maybe<CartProducts>;
  serviceAddResponse: Maybe<Array<Maybe<CartServiceAddResponse>>>;
};

export type AddProductsResponse = {
  __typename?: 'AddProductsResponse';
  productAddResponse: Maybe<Array<Maybe<CartProducts>>>;
  serviceAddResponse: Maybe<Array<Maybe<CartServiceAddResponse>>>;
};

export type AddToCartTryItFirstResult = {
  __typename?: 'AddToCartTryItFirstResult';
  status: Maybe<Array<CartProductStatus>>;
};

export type AdminPanelInfo = {
  __typename?: 'AdminPanelInfo';
  approvalStatus: Maybe<RolloutStatusType>;
  availableShops: Maybe<Array<AvailableShop>>;
  commodityId: Scalars['String'];
  displayType: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

export type AlternateSite = {
  __typename?: 'AlternateSite';
  culture: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
};

export type AppConfig = {
  __typename?: 'AppConfig';
  recaptchaSiteKey: Scalars['String'];
  shops: Maybe<Array<Shop>>;
  supportedLocales: Maybe<Array<Scalars['String']>>;
  supportedShops: Maybe<Array<Scalars['String']>>;
};

export type Article = {
  __typename?: 'Article';
  author: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  image: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type ArticlesQueryResponse = {
  __typename?: 'ArticlesQueryResponse';
  articles: Array<BlogArticle>;
  totalCount: Scalars['Int'];
};

export type ArticlesQueryVariables = {
  brandId?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<Array<Scalars['Int']>>;
  kinds?: InputMaybe<Array<Scalars['Int']>>;
  masterProductCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<Scalars['String']>>;
  subCategories?: InputMaybe<Array<Scalars['Int']>>;
  types?: InputMaybe<Array<Scalars['Int']>>;
  useNewEndpoint?: InputMaybe<Scalars['Boolean']>;
};

export type AssignGiftModel = {
  __typename?: 'AssignGiftModel';
  availability: Maybe<Scalars['Int']>;
  brand: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  count: Maybe<Scalars['Int']>;
  idAssign: Maybe<Scalars['Int']>;
  image: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  subName: Maybe<Scalars['String']>;
};

export type AssignGiftModelInput = {
  code?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  idAssign?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type AssignModel = {
  __typename?: 'AssignModel';
  assignGiftList: Maybe<Array<Maybe<AssignGiftModel>>>;
  choose: Maybe<Scalars['Int']>;
  expandInCart: Maybe<Scalars['Boolean']>;
  giftType: Maybe<GiftType>;
  id: Maybe<Scalars['Int']>;
  idActionBody: Maybe<Scalars['Int']>;
  minCount: Maybe<Scalars['Int']>;
  minSum: Maybe<Scalars['Float']>;
};

export type AssignModelInput = {
  assignGiftList?: InputMaybe<Array<InputMaybe<AssignGiftModelInput>>>;
  choose?: InputMaybe<Scalars['Int']>;
  giftType?: InputMaybe<GiftType>;
  id?: InputMaybe<Scalars['Int']>;
  idActionBody?: InputMaybe<Scalars['Int']>;
  minCount?: InputMaybe<Scalars['Int']>;
  minSum?: InputMaybe<Scalars['Float']>;
};

export enum AuthorType {
  Motivated = 'Motivated',
  Unknown = 'Unknown',
  Verified = 'Verified',
}

export type AvailableShop = {
  __typename?: 'AvailableShop';
  languageTag: Scalars['String'];
  productUrl: Scalars['String'];
  shopId: Scalars['String'];
};

export type BannerTypeModel = {
  __typename?: 'BannerTypeModel';
  bannerType: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
};

export type BazaarvoiceIntegrationType = {
  __typename?: 'BazaarvoiceIntegrationType';
  environment: Scalars['String'];
  locale: Scalars['String'];
  siteId: Scalars['String'];
};

export type Benefit = {
  __typename?: 'Benefit';
  iconId: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type BenefitsDto = {
  __typename?: 'BenefitsDto';
  fidelity: Maybe<FidelityDto>;
  loyalties: Array<LoyaltyDto>;
  vouchers: Array<VoucherDto>;
};

export type BlogArticle = {
  __typename?: 'BlogArticle';
  hreflangId: Maybe<Scalars['String']>;
  image: Maybe<BlogArticleImage>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BlogArticleImage = {
  __typename?: 'BlogArticleImage';
  alt: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Brand = {
  __typename?: 'Brand';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type BrandItem = {
  __typename?: 'BrandItem';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  link: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignId: Maybe<Scalars['String']>;
  detailPageText: Maybe<Scalars['String']>;
  displayOnDetailPage: Maybe<Scalars['Boolean']>;
  giftImageUrl: Maybe<Scalars['String']>;
  giftType: Maybe<GiftType>;
  id: Maybe<Scalars['String']>;
  imageUrl: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type CampaignConfig = {
  __typename?: 'CampaignConfig';
  allowed: Maybe<EGiftPackagingAllowedType>;
  groupName: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
};

export type CartAddedService = {
  __typename?: 'CartAddedService';
  productId: Maybe<Scalars['String']>;
  type: Maybe<CartServiceType>;
  value: Maybe<Scalars['String']>;
};

export type CartContent = {
  __typename?: 'CartContent';
  benefits: BenefitsDto;
  cartId: Scalars['String'];
  delivery: Maybe<CartContentProduct>;
  discounts: Array<DiscountDto>;
  payment: Maybe<CartContentProduct>;
  pricesSummary: PricesSummaryDto;
  products: Maybe<Array<Maybe<CartContentProduct>>>;
  serviceItems: ServiceItemsDto;
  vouchers: Array<VoucherDto>;
};

export type CartContentProduct = {
  __typename?: 'CartContentProduct';
  action: Scalars['Boolean'];
  autoInserted: Scalars['Boolean'];
  brandId: Scalars['Int'];
  categoryId: Scalars['Int'];
  count: Scalars['Int'];
  deleted: Scalars['Boolean'];
  discount: Scalars['Boolean'];
  engraving: Maybe<CustomServiceDto>;
  freeProduct: Scalars['Boolean'];
  giftCampaignId: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  isNiche: Scalars['Boolean'];
  isService: Scalars['Boolean'];
  isVirtualService: Scalars['Boolean'];
  itemId: Scalars['Int'];
  priceSumWithVat: Scalars['Int'];
  priceWithVat: Scalars['Int'];
  productCode: Scalars['String'];
  productElisId: Scalars['Int'];
  productId: Scalars['Int'];
  tryItFirstId: Scalars['Int'];
  upselling: Scalars['Boolean'];
  usedProduct: Scalars['Boolean'];
  vat: Scalars['Int'];
};

export type CartItemDto = {
  __typename?: 'CartItemDto';
  action: Maybe<Scalars['Boolean']>;
  autoInserted: Maybe<Scalars['Boolean']>;
  count: Maybe<Scalars['Int']>;
  customServices: Maybe<CartItemDto_CustomServices>;
  deleleted: Maybe<Scalars['Boolean']>;
  discount: Maybe<Scalars['Boolean']>;
  freeProduct: Maybe<Scalars['Boolean']>;
  giftCampaignId: Maybe<Scalars['Int']>;
  ident: Maybe<Scalars['String']>;
  isService: Maybe<Scalars['Boolean']>;
  itemId: Maybe<Scalars['Int']>;
  priceSumWithVat: Maybe<Scalars['Float']>;
  priceWithVat: Maybe<Scalars['Float']>;
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  upselling: Maybe<Scalars['Boolean']>;
  usedProduct: Maybe<Scalars['Boolean']>;
  vat: Maybe<Scalars['Float']>;
};

export type CartItemDto_CustomServices = {
  __typename?: 'CartItemDto_customServices';
  /** default field */
  success: Maybe<Scalars['String']>;
};

export type CartItemProxyResponseModelInput = {
  count?: InputMaybe<Scalars['Int']>;
  priceWithVat?: InputMaybe<Scalars['Float']>;
  productCode?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type CartProduct = {
  __typename?: 'CartProduct';
  comparisonPrice: Maybe<Scalars['Boolean']>;
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  isUpselling: Maybe<Scalars['Boolean']>;
  product: Maybe<VpProduct>;
  status: Array<Maybe<CartProductStatus>>;
};

export enum CartProductStatus {
  Default = 'Default',
  Error = 'Error',
  NoCreateCart = 'NoCreateCart',
  OutOfPriceLimit = 'OutOfPriceLimit',
  ReducedCount = 'ReducedCount',
  ShowSoldOutWarning = 'ShowSoldOutWarning',
  Sold = 'Sold',
  Success = 'Success',
  UseProductInCart = 'UseProductInCart',
  VoucherOnline = 'VoucherOnline',
}

export type CartProducts = {
  __typename?: 'CartProducts';
  cart: CartContent;
  itemId: Scalars['Int'];
  messages: Array<Scalars['String']>;
  productId: Scalars['Int'];
  productIncrease: Scalars['Int'];
};

export type CartServiceAddResponse = {
  __typename?: 'CartServiceAddResponse';
  message: Maybe<Scalars['String']>;
  service: Maybe<CartAddedService>;
  status: Array<Maybe<CartProductStatus>>;
};

export type CartServiceInput = {
  count?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  type: CartServiceType;
  value: Scalars['String'];
};

export enum CartServiceType {
  Engraving = 'Engraving',
}

export enum CartStatusType {
  Default = 'Default',
  Error = 'Error',
  InternalError = 'InternalError',
  NotFound = 'NotFound',
  Success = 'Success',
  Warning = 'Warning',
}

export type Categorization = {
  __typename?: 'Categorization';
  categories: Maybe<Array<CategorizationItem>>;
  kinds: Maybe<Array<CategorizationItem>>;
  subCategories: Maybe<Array<CategorizationItem>>;
  types: Maybe<Array<CategorizationItem>>;
};

export type CategorizationItem = {
  __typename?: 'CategorizationItem';
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
};

export type Characteristic = {
  __typename?: 'Characteristic';
  help: Maybe<Scalars['String']>;
  /** @deprecated Not supported by server. */
  link: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  values: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClickAndCollectStore = {
  __typename?: 'ClickAndCollectStore';
  code: Scalars['String'];
  description: Scalars['String'];
  earliestPickup: Scalars['String'];
  location: Location;
  name: Scalars['String'];
  stockCount: StockAvailability;
};

export type ClientCache = {
  __typename?: 'ClientCache';
  hasWebcam: Maybe<Scalars['Boolean']>;
};

export type ClientHeaders = {
  __typename?: 'ClientHeaders';
  abTest: Maybe<Scalars['String']>;
  assetsPath: Scalars['String'];
  authorization: Scalars['String'];
  features: Scalars['String'];
  gatewayUrl: Scalars['String'];
  groupId: Scalars['String'];
  hrkDefaultCurrency: HrkDefaultCurrency;
  lastVisitedProducts: Maybe<Array<Scalars['String']>>;
  ldFlags: LdFeatures;
  modifaceDomain: Maybe<Scalars['String']>;
  mounts: Array<Scalars['String']>;
  originUrl: Maybe<Scalars['String']>;
  role: Scalars['String'];
  sentryDsn: Scalars['String'];
  sentryEnvironment: Scalars['String'];
  sentryTracingRate: Scalars['Float'];
  shadefinderAppId: Maybe<Scalars['String']>;
  shopId: Scalars['String'];
  userEmail: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userName: Maybe<Scalars['String']>;
  xAbTest: Maybe<Scalars['String']>;
  xLangTag: Maybe<Scalars['String']>;
  xUserToken: Maybe<Scalars['String']>;
};

export type ClientProductSsr = {
  __typename?: 'ClientProductSsr';
  id: Maybe<Scalars['String']>;
  pathname: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type ClientWatchdog = {
  __typename?: 'ClientWatchdog';
  errors: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  success: Scalars['String'];
};

export type ClientWatchdogs = {
  __typename?: 'ClientWatchdogs';
  list: Array<Maybe<ClientWatchdog>>;
};

export type Cloudflare = {
  __typename?: 'Cloudflare';
  baseUrl: Scalars['String'];
  enabled: Scalars['Boolean'];
  quality: Scalars['Int'];
};

export type CompositionTables = {
  __typename?: 'CompositionTables';
  nutritionValues: Maybe<Array<NutritionValue>>;
  vitaminsAndMinerals: Maybe<Array<VitaminsAndMinerals>>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  symbol: Maybe<Scalars['String']>;
};

export type CustomServiceDto = {
  __typename?: 'CustomServiceDto';
  cartItemId: Scalars['Int'];
  cartServiceItem: Scalars['Int'];
  priceWithVat: Scalars['Int'];
  value: Scalars['String'];
};

export type CustomerBenefits = {
  __typename?: 'CustomerBenefits';
  brandDiscountLimit: Maybe<Scalars['Int']>;
  brandDiscounts: Maybe<Array<Maybe<CustomerBenefitsDiscount>>>;
  categoryDiscountLimit: Maybe<Scalars['Int']>;
  categoryDiscounts: Maybe<Array<Maybe<CustomerBenefitsDiscount>>>;
  hasActiveBenefits: Maybe<Scalars['Boolean']>;
};

export type CustomerBenefitsDiscount = {
  __typename?: 'CustomerBenefitsDiscount';
  subjectName: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Int']>;
};

export type CustomerInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type DefaultCurrency = {
  __typename?: 'DefaultCurrency';
  code: Scalars['String'];
  currencyId: Maybe<Scalars['Int']>;
  symbol: Maybe<Scalars['String']>;
};

export type DeleteAction = {
  __typename?: 'DeleteAction';
  /** default field */
  empty: Maybe<Scalars['String']>;
};

export type Delivery = {
  __typename?: 'Delivery';
  date: Maybe<Scalars['String']>;
  dateFrom: Maybe<Scalars['String']>;
  dateTo: Maybe<Scalars['String']>;
  disallowedReason: Maybe<Scalars['String']>;
  isAirTransport: Maybe<Scalars['Boolean']>;
  isPersonal: Maybe<Scalars['Boolean']>;
  name: Maybe<Scalars['String']>;
};

export type DesiredShade = {
  __typename?: 'DesiredShade';
  darker: Maybe<RecommendedProduct>;
  ideal: Maybe<RecommendedProduct>;
  lighter: Maybe<RecommendedProduct>;
};

export type Discount = {
  __typename?: 'Discount';
  discountSubject: Maybe<Scalars['String']>;
  discountType: Maybe<DiscountType>;
  subjectType: Maybe<SubjectType>;
  value: Maybe<Scalars['Int']>;
};

export type DiscountDto = {
  __typename?: 'DiscountDto';
  priority: Scalars['Int'];
  type: EDiscountType;
  value: Scalars['Int'];
};

export enum DiscountType {
  Absolute = 'Absolute',
  Percentage = 'Percentage',
  Unknown = 'Unknown',
}

export enum EBenefitState {
  Active = 'Active',
  Disabled = 'Disabled',
  NotExistForUser = 'NotExistForUser',
}

export enum EDiscountType {
  AbsoluteWithVat = 'AbsoluteWithVat',
  AbsoluteWithoutVat = 'AbsoluteWithoutVat',
  Percentage = 'Percentage',
}

export enum EGiftPackagingAllowedType {
  Brand = 'Brand',
  None = 'None',
  Product = 'Product',
}

export enum ELoyaltyDiscountType {
  BrandDiscount = 'BrandDiscount',
  CategoryDiscount = 'CategoryDiscount',
  FreeDelivery = 'FreeDelivery',
}

export enum EStatus {
  Default = 'Default',
  Error = 'Error',
  Fail = 'Fail',
  NoCreateCart = 'NoCreateCart',
  NotFoundProduct = 'NotFoundProduct',
  OutOfLimit = 'OutOfLimit',
  OutOfPriceLimit = 'OutOfPriceLimit',
  ReducedCount = 'ReducedCount',
  Sold = 'Sold',
  Success = 'Success',
  UseProductInCart = 'UseProductInCart',
  VoucherAndProductNotAllowed = 'VoucherAndProductNotAllowed',
  Warning = 'Warning',
}

export type Engraving = {
  __typename?: 'Engraving';
  allowed: Maybe<Scalars['Boolean']>;
  characterCount: Maybe<Scalars['Int']>;
  config: Maybe<EngravingConfig>;
  image: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
};

export type EngravingConfig = {
  __typename?: 'EngravingConfig';
  isActive: Maybe<Scalars['Boolean']>;
  isAvailable: Maybe<Scalars['Boolean']>;
  limit: Maybe<Scalars['Int']>;
  orderedCount: Maybe<Scalars['Int']>;
  price: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['String']>;
  servicesType: Maybe<Scalars['String']>;
};

export type EventCalendarDay = {
  __typename?: 'EventCalendarDay';
  /** @deprecated Use 'brands' instead */
  brand: Maybe<Brand>;
  brands: Maybe<Array<Maybe<Brand>>>;
  buttonText: Maybe<Scalars['String']>;
  date: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  filterId: Maybe<Array<Maybe<Scalars['Int']>>>;
  filterType: Maybe<Scalars['String']>;
  giftAvailable: Maybe<Scalars['Boolean']>;
  largeImage: Maybe<Scalars['String']>;
  smallImage: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  todayItem: Maybe<Scalars['Boolean']>;
  url: Maybe<Scalars['String']>;
  voucher: Maybe<Scalars['String']>;
};

export type FeatureSwitches = {
  __typename?: 'FeatureSwitches';
  addToCartResendDelay: Maybe<Scalars['String']>;
  addToCartWarningCount: Maybe<Scalars['String']>;
  hideReviewsABTest: Maybe<Scalars['String']>;
  modifaceDesktopEnabled: Maybe<Scalars['String']>;
  modifaceMobileEnabled: Maybe<Scalars['String']>;
  reviewsOnServerIds: Maybe<Scalars['String']>;
};

export type FidelityDto = {
  __typename?: 'FidelityDto';
  moneyValue: Scalars['Int'];
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
};

export type Filter = {
  __typename?: 'Filter';
  key: Scalars['String'];
  value: Maybe<Scalars['String']>;
};

export type FilterInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type FilterModel = {
  __typename?: 'FilterModel';
  filter: Scalars['String'];
  id: Maybe<Scalars['Int']>;
  idActionBody: Maybe<Scalars['Int']>;
};

export type FilterModelInput = {
  filter: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  idActionBody?: InputMaybe<Scalars['Int']>;
};

export type Flag = {
  __typename?: 'Flag';
  countryCode: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Footer = {
  __typename?: 'Footer';
  benefits: Maybe<Array<Maybe<Benefit>>>;
  copyrightText: Maybe<Scalars['String']>;
  flags: Maybe<Array<Maybe<Flag>>>;
  footerText: Maybe<FooterText>;
  linksSections: Maybe<Array<Maybe<LinkSection>>>;
  partners: Maybe<Array<Maybe<Partner>>>;
  payments: Maybe<Array<Maybe<Payment>>>;
  places: Maybe<Array<Maybe<Place>>>;
  quickContact: Maybe<QuickContact>;
  socialIcons: Maybe<Array<Maybe<SocialIcon>>>;
};

export type FooterText = {
  __typename?: 'FooterText';
  homePage: Maybe<HomePageFooter>;
};

export type Freetext = {
  __typename?: 'Freetext';
  content: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type GdprSettings = {
  __typename?: 'GdprSettings';
  securityAndPrivacyUrl: Maybe<Scalars['String']>;
  termsAndConditionsUrl: Maybe<Scalars['String']>;
};

export type GetLivestreamResponse = {
  __typename?: 'GetLivestreamResponse';
  shows: Maybe<Array<Livestream>>;
};

export type GetLivestreamVariables = {
  productCode: Scalars['String'];
};

export type GetShoppingCartContentProxyResponseModelInput = {
  cartId?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<CartItemProxyResponseModelInput>>>;
};

export type GiftAddDtoInput = {
  campaignId?: InputMaybe<Scalars['Int']>;
  count: Scalars['Int'];
  productId: Scalars['Int'];
};

export type GiftModel = {
  __typename?: 'GiftModel';
  code: Scalars['String'];
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['Int']>;
  idAction: Maybe<Scalars['Int']>;
  productId: Maybe<Scalars['Int']>;
};

export type GiftModelInput = {
  code: Scalars['String'];
  count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  idAction?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type GiftPackagingConfig = {
  __typename?: 'GiftPackagingConfig';
  allowed: Maybe<EGiftPackagingAllowedType>;
  price: Maybe<Scalars['Float']>;
};

export enum GiftType {
  Basic = 'BASIC',
  Gwp = 'GWP',
  Sample = 'SAMPLE',
  Special = 'SPECIAL',
  TryItFirst = 'TRY_IT_FIRST',
}

export type GiftTypeModel = {
  __typename?: 'GiftTypeModel';
  giftType: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
};

export type HairModifaceEffects = {
  __typename?: 'HairModifaceEffects';
  category: Maybe<Scalars['String']>;
  shades: Maybe<Array<Maybe<ModifaceHairShade>>>;
  upc: Maybe<Scalars['String']>;
};

export type HomePageFooter = {
  __typename?: 'HomePageFooter';
  leftSideHtml: Maybe<Scalars['String']>;
  rightSideHtml: Maybe<Scalars['String']>;
};

export type HrkDefaultCurrency = {
  __typename?: 'HrkDefaultCurrency';
  code: Scalars['String'];
  currencyId: Scalars['Int'];
  exchangeRates: Maybe<HrkExchangeRates>;
  symbol: Scalars['String'];
};

export type HrkExchangeRates = {
  __typename?: 'HrkExchangeRates';
  EUR: Maybe<Scalars['Float']>;
  HRK: Maybe<Scalars['Float']>;
};

export type Image = {
  __typename?: 'Image';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
};

export type ImagesByCategory = {
  __typename?: 'ImagesByCategory';
  mainImage: Image;
  others: Maybe<Array<Maybe<Image>>>;
  previewImage: Maybe<Image>;
  shadeImage: Maybe<Image>;
};

export type InstructionDocument = {
  __typename?: 'InstructionDocument';
  type: InstructionDocumentType;
  url: Scalars['String'];
};

export enum InstructionDocumentType {
  InstructionsForUse = 'InstructionsForUse',
  PackagingInformation = 'PackagingInformation',
}

export type ItemInCart = {
  __typename?: 'ItemInCart';
  cartItemId: Scalars['Int'];
  count: Maybe<Scalars['Int']>;
  price: Maybe<Scalars['Int']>;
  productId: Maybe<Scalars['Int']>;
  warning: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ItemResponse = {
  __typename?: 'ItemResponse';
  itemId: Maybe<Scalars['Int']>;
};

export type Language = {
  __typename?: 'Language';
  langId: Maybe<Scalars['Int']>;
  priceDecimalPlaces: Maybe<Scalars['Int']>;
  priceFormat: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type LanguagedMessage = {
  __typename?: 'LanguagedMessage';
  acceptLanguage: Scalars['String'];
  messages: Maybe<Scalars['JSON']>;
};

export type LdFeatures = {
  __typename?: 'LdFeatures';
  bazaarvoiceCookieConsentMapping: Maybe<Scalars['Boolean']>;
  bazaarvoiceIntegrationPd: Maybe<BazaarvoiceIntegrationType>;
  chatbot: Maybe<Scalars['Boolean']>;
  conditionalVoucherDiscount: Maybe<Scalars['Boolean']>;
  dualCurrencyPrice: Maybe<Scalars['Boolean']>;
  gatewayRouterProxyEnabled: Maybe<Scalars['Boolean']>;
  hasJsonLdOfferVoucherPrice: Maybe<Scalars['Boolean']>;
  klarnaNushopId: Maybe<Scalars['String']>;
  livestreamOnPdEnabled: Maybe<Scalars['Boolean']>;
  loyaltyGa4: Maybe<Scalars['Boolean']>;
  modifaceIntensitySlider: Maybe<Scalars['Boolean']>;
  newBlogEndpoint: Maybe<Scalars['Boolean']>;
  newDermoIcon: Maybe<Scalars['Boolean']>;
  newNutritionAndVitaminsTable: Maybe<Scalars['Boolean']>;
  newPdDesign: Maybe<Scalars['Boolean']>;
  pdHasAllReviewsPage: Maybe<Scalars['Boolean']>;
  pdSetImmediateEnabled: Maybe<Scalars['Boolean']>;
  pictogramsEnabled: Maybe<Scalars['Boolean']>;
  recoProductDetail: Maybe<Scalars['Boolean']>;
  recoProductDetailAddToCart: Maybe<Scalars['Boolean']>;
  shadeFinderTryItFirstProductMasterIds: Maybe<Array<Scalars['String']>>;
  shadefinderEnabled: Maybe<Scalars['Boolean']>;
  spaRedirectWishlistToPd: Maybe<Scalars['Boolean']>;
  strictSalesDisplay: Maybe<Scalars['Boolean']>;
  swogoIgnoreConvertedPrice: Maybe<Scalars['Boolean']>;
  swogoIntegrationEnabled: Maybe<Scalars['Boolean']>;
  virtualTryOnState: Maybe<Scalars['String']>;
  voucherNewDesign: Maybe<Scalars['Boolean']>;
  wishlistSsrEnabled: Maybe<Scalars['Boolean']>;
};

export type LegalInformation = {
  __typename?: 'LegalInformation';
  compositionTables: Maybe<CompositionTables>;
  document: Maybe<Scalars['String']>;
  foodComposition: Maybe<Scalars['String']>;
  importantNotice: Maybe<Scalars['String']>;
  ingredients: Maybe<Scalars['String']>;
  instructionDocument: Maybe<InstructionDocument>;
  instructions: Maybe<Scalars['String']>;
  isSensitiveHairProduct: Maybe<Scalars['Boolean']>;
  manufacturerImporter: Maybe<Scalars['String']>;
  nutritionValues: Maybe<Scalars['String']>;
  preparationUsage: Maybe<Scalars['String']>;
  specialStorage: Maybe<Scalars['String']>;
  video: Maybe<Scalars['String']>;
  warnings: Maybe<Scalars['String']>;
};

export type Link = {
  __typename?: 'Link';
  targetUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type LinkSection = {
  __typename?: 'LinkSection';
  links: Maybe<Array<Maybe<Link>>>;
  sectionType: Maybe<SectionType>;
};

export type Livestream = {
  __typename?: 'Livestream';
  deeplink: Scalars['String'];
  description: Scalars['String'];
  isLive: Scalars['Boolean'];
  previewImageUrl: Scalars['String'];
  publishedDate: Maybe<Scalars['String']>;
  scheduledDate: Scalars['String'];
  scheduledStart: Maybe<Scalars['String']>;
  showId: Scalars['String'];
  title: Scalars['String'];
  videoLength: Scalars['String'];
};

export type Locale = {
  __typename?: 'Locale';
  currency: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  priceDecimalPlaces: Maybe<Scalars['Int']>;
  priceFormat: Maybe<Scalars['String']>;
  tag: Maybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['String'];
  longitude: Scalars['String'];
};

export type LoggedInUserReview = {
  __typename?: 'LoggedInUserReview';
  digests: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  ipAddress: Maybe<Scalars['String']>;
  masterProductCode: Scalars['String'];
  name: Scalars['String'];
  ratings: Maybe<Array<ReviewRating>>;
  score: Scalars['Int'];
  source: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type LoyaltyDto = {
  __typename?: 'LoyaltyDto';
  benefitId: Scalars['String'];
  code: Scalars['String'];
  loyaltyType: ELoyaltyDiscountType;
  state: EBenefitState;
  value: Scalars['Int'];
};

export type MasterProductListItem = {
  __typename?: 'MasterProductListItem';
  annotation: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  masterId: Maybe<Scalars['Int']>;
  masterProductCode: Maybe<Scalars['String']>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview. */
  reviewSummary: Maybe<ReviewSummary>;
  url: Maybe<Scalars['String']>;
  variants: Array<Maybe<ProductListItem>>;
};

export type MissAlreadyVoted = {
  __typename?: 'MissAlreadyVoted';
  facebookAppId: Maybe<Scalars['String']>;
  user: Maybe<User>;
  voted: Maybe<Scalars['Boolean']>;
};

export type MissVoteCustomerInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type MissVoteInput = {
  customer: MissVoteCustomerInput;
  missId: Scalars['Int'];
};

export type MissVotePayload = {
  __typename?: 'MissVotePayload';
  data: Maybe<Scalars['String']>;
  status: Maybe<MissVoteStatus>;
};

export enum MissVoteStatus {
  AlreadyVoted = 'ALREADY_VOTED',
  Error = 'ERROR',
  Ok = 'OK',
}

export type ModifaceEffect = {
  __typename?: 'ModifaceEffect';
  category: Maybe<Scalars['String']>;
  shades: Maybe<Array<Maybe<ModifaceEffectShade>>>;
  upc: Maybe<Scalars['String']>;
};

export type ModifaceEffectShade = {
  __typename?: 'ModifaceEffectShade';
  color_a: Maybe<Scalars['Int']>;
  color_b: Maybe<Scalars['Int']>;
  color_g: Maybe<Scalars['Int']>;
  color_r: Maybe<Scalars['Int']>;
  contrastBoost: Maybe<Scalars['Float']>;
  gamma: Maybe<Scalars['Float']>;
  glossDetail: Maybe<Scalars['Float']>;
  intensity: Maybe<Scalars['Float']>;
  placement: Maybe<Scalars['String']>;
  skinClearing: Maybe<Scalars['Float']>;
  skinGlow: Maybe<Scalars['Float']>;
  sparkle_a: Maybe<Scalars['Float']>;
  sparkle_b: Maybe<Scalars['Int']>;
  sparkle_g: Maybe<Scalars['Int']>;
  sparkle_r: Maybe<Scalars['Int']>;
  wetness: Maybe<Scalars['Float']>;
};

export type ModifaceHairShade = {
  __typename?: 'ModifaceHairShade';
  blendGradientBottomOffset: Maybe<Scalars['Int']>;
  blendGradientTopOffset: Maybe<Scalars['Int']>;
  effect: Maybe<Scalars['Int']>;
  enableRootRecoloring: Maybe<Scalars['Boolean']>;
  family: Maybe<Scalars['String']>;
  histogram_b: Maybe<Scalars['String']>;
  histogram_c: Maybe<Scalars['String']>;
  histogram_g: Maybe<Scalars['String']>;
  histogram_r: Maybe<Scalars['String']>;
  intensity: Maybe<Scalars['Float']>;
  renderingVersion: Maybe<Scalars['Int']>;
  shazamColorFamily: Maybe<Scalars['String']>;
  shine: Maybe<Scalars['Float']>;
  totalpixels: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddGiftToCart: Maybe<ItemResponse>;
  AddProductToCart: AddProductResponse;
  AddProductsToCart: AddProductsResponse;
  DeleteGiftFromCart: Maybe<Scalars['String']>;
  DeleteProductFromCart: Maybe<ShoppingCartModel>;
  GiftAddAction: Maybe<ActionModel>;
  GiftDeleteAction: Maybe<DeleteAction>;
  GiftUpdateAction: Maybe<ActionModel>;
  TryItFirstAddToCart: AddToCartTryItFirstResult;
  WishlistAddProduct: Maybe<Wishlist>;
  WishlistAddProductByOwner: Maybe<Wishlist>;
  WishlistCopyWishlist: Maybe<WishlistId>;
  WishlistMergeWishlists: Maybe<Wishlist>;
  WishlistRemoveProduct: Maybe<Wishlist>;
  WishlistRemoveProductByOwner: Maybe<Wishlist>;
  addProductToClickAndCollect: Maybe<ShoppingCartModel>;
  addReview: Maybe<ReviewResponse>;
  dummy: Maybe<Scalars['String']>;
  handleVote: Maybe<Review>;
  missSaveVote: Maybe<MissVotePayload>;
  samplingCreateOrder: SamplingOrderResponse;
  sendWatchdog: WatchDog;
  setActualProduct: Maybe<ActualProduct>;
  storeWatchdog: Maybe<Array<Maybe<ClientWatchdog>>>;
  tnbCreateNewToken: Scalars['String'];
  tnbCreateOrder: TnbOrderResponse;
  tnbMakeOrder: Maybe<TnbMakeOrderResponse>;
  tnbSmsValidation: Maybe<Scalars['ID']>;
};

export type MutationAddGiftToCartArgs = {
  gift: GiftAddDtoInput;
};

export type MutationAddProductToCartArgs = {
  product: ProductToCartInput;
  services?: InputMaybe<Array<InputMaybe<CartServiceInput>>>;
};

export type MutationAddProductsToCartArgs = {
  products: Array<ProductToCartInput>;
  services?: InputMaybe<Array<InputMaybe<CartServiceInput>>>;
};

export type MutationDeleteGiftFromCartArgs = {
  itemId: Scalars['Int'];
};

export type MutationDeleteProductFromCartArgs = {
  itemId: Scalars['Int'];
};

export type MutationGiftAddActionArgs = {
  action?: InputMaybe<ActionModelInput>;
};

export type MutationGiftDeleteActionArgs = {
  id: Scalars['Int'];
};

export type MutationGiftUpdateActionArgs = {
  action?: InputMaybe<ActionModelInput>;
};

export type MutationTryItFirstAddToCartArgs = {
  productCode: Scalars['String'];
  productId: Scalars['String'];
  tryItFirstId: Scalars['String'];
};

export type MutationWishlistAddProductArgs = {
  product: Scalars['String'];
};

export type MutationWishlistAddProductByOwnerArgs = {
  owner: Scalars['String'];
  product: Scalars['String'];
};

export type MutationWishlistCopyWishlistArgs = {
  anonymousId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
};

export type MutationWishlistMergeWishlistsArgs = {
  newOwner: Scalars['String'];
  owner: Scalars['String'];
};

export type MutationWishlistRemoveProductArgs = {
  product: Scalars['String'];
};

export type MutationWishlistRemoveProductByOwnerArgs = {
  owner: Scalars['String'];
  product: Scalars['String'];
};

export type MutationAddProductToClickAndCollectArgs = {
  productId: Scalars['Int'];
  warehouseCode: Scalars['String'];
};

export type MutationAddReviewArgs = {
  digests?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  masterProductCode: Scalars['String'];
  name: Scalars['String'];
  ratings?: InputMaybe<Array<InputMaybe<Rating>>>;
  score: Scalars['Int'];
  source: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type MutationHandleVoteArgs = {
  action: VoteAction;
  id: Scalars['String'];
  type: VoteType;
};

export type MutationMissSaveVoteArgs = {
  voteInput: MissVoteInput;
  year: Scalars['String'];
};

export type MutationSamplingCreateOrderArgs = {
  campaignId: Scalars['Int'];
  customer: CustomerInput;
};

export type MutationSendWatchdogArgs = {
  email: Scalars['String'];
  productId: Scalars['String'];
};

export type MutationSetActualProductArgs = {
  id: Scalars['String'];
};

export type MutationStoreWatchdogArgs = {
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MutationTnbCreateNewTokenArgs = {
  productCode: Scalars['String'];
};

export type MutationTnbCreateOrderArgs = {
  order?: InputMaybe<TnbOrderInput>;
};

export type MutationTnbMakeOrderArgs = {
  order: TnbMakeOrderInput;
};

export type MutationTnbSmsValidationArgs = {
  validationData: TnbSmsValidationInput;
};

export type NutritionValue = {
  __typename?: 'NutritionValue';
  amount: Maybe<Scalars['Float']>;
  amountSign: Maybe<Scalars['String']>;
  measureUnit: Maybe<Scalars['String']>;
  nutritionValue: Maybe<Scalars['String']>;
  variantAmount: Maybe<Scalars['Float']>;
};

export type OriginalPrice = {
  __typename?: 'OriginalPrice';
  currency: Maybe<Scalars['String']>;
  tax: Maybe<Scalars['Float']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type Pager = {
  __typename?: 'Pager';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  remaining: Scalars['Int'];
};

export type PagerInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type Parameters = {
  __typename?: 'Parameters';
  amount: Maybe<Scalars['Float']>;
  package: Maybe<Scalars['String']>;
};

export type Partner = {
  __typename?: 'Partner';
  externalCode: Maybe<Scalars['String']>;
  imagePath: Maybe<Scalars['String']>;
  linkUrl: Maybe<Scalars['String']>;
  onlyOnHomepage: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
  type: Maybe<PartnerType>;
};

export enum PartnerType {
  External = 'External',
  Internal = 'Internal',
}

export enum PathTemplate {
  Error = 'Error',
  HomePage = 'HomePage',
  NotFound = 'NotFound',
  ProductDetailSimple = 'ProductDetailSimple',
  ReviewsPage = 'ReviewsPage',
  SpecialPageComponent = 'SpecialPageComponent',
  Tryandbuy = 'Tryandbuy',
  Wishlist = 'Wishlist',
}

export type PathView = {
  __typename?: 'PathView';
  id: Scalars['ID'];
  path: Scalars['String'];
  productId: Maybe<Scalars['String']>;
  type: PathTemplate;
};

export type Payment = {
  __typename?: 'Payment';
  imageUrl: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type Place = {
  __typename?: 'Place';
  name: Maybe<Scalars['String']>;
  stores: Maybe<Array<Maybe<Store>>>;
};

export type Price = {
  __typename?: 'Price';
  currency: Maybe<Scalars['String']>;
  tax: Maybe<Scalars['Float']>;
  value: Maybe<Scalars['Float']>;
};

export type PriceLevel = {
  __typename?: 'PriceLevel';
  levels: Maybe<Array<PriceLevelItem>>;
};

export type PriceLevelItem = {
  __typename?: 'PriceLevelItem';
  value: Scalars['Int'];
};

export type PricesSummaryDto = {
  __typename?: 'PricesSummaryDto';
  discountWithoutDelivery: Scalars['Int'];
  priceDelivery: Scalars['Int'];
  priceItemSummary: Scalars['Int'];
  pricePayment: Scalars['Int'];
  priceProductsSummary: Scalars['Int'];
  vat: Scalars['Int'];
};

export type PrimaryCategories = {
  __typename?: 'PrimaryCategories';
  category: Scalars['String'];
  kind: Scalars['String'];
  subCategory: Scalars['String'];
  type: Scalars['String'];
};

export type Product = {
  __typename?: 'Product';
  alternateSites: Maybe<Array<Maybe<AlternateSite>>>;
  annotation: Maybe<Scalars['String']>;
  /** @deprecated Use brandInfo. */
  brand: Maybe<Scalars['String']>;
  /** @deprecated Use brandInfo. */
  brandId: Maybe<Scalars['Int']>;
  brandInfo: Maybe<Brand>;
  /** @deprecated Use brandInfo. */
  brandRef: Maybe<Brand>;
  breadcrumb: Maybe<Array<Maybe<Breadcrumb>>>;
  campaigns: Maybe<Array<Maybe<Campaign>>>;
  categorization: Categorization;
  category: Maybe<Array<Maybe<Scalars['String']>>>;
  /** @deprecated Use characteristics of specific variant. */
  characteristics: Maybe<Array<Maybe<Characteristic>>>;
  code: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  composition: Maybe<Array<Maybe<Characteristic>>>;
  config: ProductConfig;
  deliveries: Maybe<Array<Maybe<Delivery>>>;
  description: Maybe<Scalars['String']>;
  hasDifferentColors: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isForbiddenToDisplay: Maybe<Scalars['Boolean']>;
  isPerfume: Maybe<Scalars['Boolean']>;
  isShadeFinderAvailable: Maybe<Scalars['Boolean']>;
  kind: Maybe<Scalars['String']>;
  manufacturer: Maybe<Scalars['String']>;
  marketType: Maybe<Scalars['String']>;
  orderUnit: Maybe<Scalars['String']>;
  primaryCategories: PrimaryCategories;
  /** @deprecated Use reviewOverview. This return always null. */
  rating: Maybe<ProductRating>;
  related: Maybe<Array<Maybe<Product>>>;
  /** @deprecated Use 'getArticles' instead. */
  relatedArticles: Maybe<Array<Maybe<Article>>>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview instead. ReviewOverview is more effective and faster to resolve. */
  reviewSummary: Maybe<ReviewSummary>;
  seo: Maybe<Seo>;
  subCategory: Maybe<Array<Maybe<Scalars['String']>>>;
  subName: Maybe<Scalars['String']>;
  type: Maybe<Array<Maybe<Scalars['String']>>>;
  unit: Maybe<Scalars['String']>;
  /** @deprecated Use perAmount directly inside unitPrice. */
  unitAmount: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  variantDisplayType: Maybe<VariantDisplayType>;
  variants: Maybe<Array<Maybe<Variant>>>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  showAddToCartButton: Maybe<Scalars['Boolean']>;
  showAddToCartModal: Maybe<Scalars['Boolean']>;
};

export type ProductListItem = {
  __typename?: 'ProductListItem';
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  canBuy: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  images: ImagesByCategory;
  name: Maybe<Scalars['String']>;
  parameters: Maybe<Parameters>;
  price: Maybe<Price>;
  productCode: Maybe<Scalars['String']>;
  showWatchdog: Scalars['Boolean'];
  stockAvailability: Maybe<StockInfo>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  currencyCode: Maybe<Scalars['String']>;
  originalPrice: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
  productId: Maybe<Scalars['String']>;
  unitPrice: Maybe<Scalars['Float']>;
};

export type ProductRating = {
  __typename?: 'ProductRating';
  score: Maybe<Scalars['Float']>;
  votes: Maybe<Scalars['Int']>;
};

export type ProductToCartInput = {
  count: Scalars['Int'];
  isComparisonPrice?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
};

export type ProductVariantCoreInfo = {
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  productCode: Maybe<Scalars['String']>;
  stockAvailability: Maybe<StockInfo>;
  url: Maybe<Scalars['String']>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  AdminPanelInfo: Maybe<AdminPanelInfo>;
  AppConfig: AppConfig;
  AvailableGiftsByCartContent: Maybe<Array<Maybe<AssignModel>>>;
  AvailableGiftsByCartId: Maybe<Array<Maybe<AssignModel>>>;
  CartServicesIncluded: Maybe<ServicesIncluded>;
  ClientCache: Maybe<ClientCache>;
  Footer: Maybe<Footer>;
  GetShoppingCart: Maybe<ShoppingCartModel>;
  GiftGetActionCountries: Maybe<Array<Maybe<Scalars['String']>>>;
  GiftGetActionTypes: Maybe<ActionTypesModel>;
  GiftGetActions: Maybe<Array<Maybe<ActionModel>>>;
  ProductSsrData: Maybe<ClientProductSsr>;
  RequestHeaders: Maybe<ClientHeaders>;
  RichContentAvailable: RichContentAvailable;
  RichContentData: RichContentAvailability;
  RoutineByProductId: RoutineAvailability;
  RoutineItem: Maybe<VpProduct>;
  Settings: Settings;
  VPByProductId: Maybe<VpAvailability>;
  VPCampaignNames: Maybe<Array<Maybe<VpCampaignName>>>;
  /** @deprecated Use WishlistByLoggedUserOrOwner */
  WishlistByLoggedUser: Maybe<Wishlist>;
  WishlistByLoggedUserOrOwner: Maybe<Wishlist>;
  /** @deprecated Use WishlistByLoggedUserOrOwner */
  WishlistByOwner: Maybe<Wishlist>;
  brand: Maybe<Brand>;
  brands: Maybe<Array<Maybe<BrandItem>>>;
  checkUserNewsletterStatus: Scalars['Boolean'];
  collectStoresByProductId: Maybe<Array<ClickAndCollectStore>>;
  currencies: Maybe<Array<Maybe<Currency>>>;
  currentCurrency: Currency;
  currentLocale: Locale;
  customerBenefits: Maybe<CustomerBenefits>;
  dummy: Maybe<Scalars['String']>;
  eventCalendarByYear: Array<Maybe<EventCalendarDay>>;
  freetext: Maybe<Freetext>;
  getArticles: Maybe<ArticlesQueryResponse>;
  getLivestreams: Maybe<GetLivestreamResponse>;
  getRecommendedProducts: Array<Scalars['String']>;
  getShadefinder: Maybe<ShadefinderResponse>;
  getUpsellingProducts: Array<Scalars['String']>;
  getUpsellingProductsForMultiple: Array<Scalars['String']>;
  isValidEmail: ValidEmail;
  languagedMessages: LanguagedMessage;
  languagedMessagesByPrefixes: LanguagedMessage;
  localeByShopId: Maybe<Locale>;
  locales: Maybe<Array<Maybe<Locale>>>;
  loggedInUserReview: Maybe<LoggedInUserReview>;
  missAlreadyVoted: Maybe<MissAlreadyVoted>;
  missVotedByEmail: Maybe<Scalars['Boolean']>;
  modifaceHairLicenceByHostName: Scalars['String'];
  modifaceLicenceByHostName: Scalars['String'];
  product: Product;
  productBySCode: Maybe<VpProduct>;
  productDetailByMasterId: Maybe<Array<Maybe<Product>>>;
  productDetailByStore: Maybe<StoreProduct>;
  productIdBySCode: Maybe<Scalars['Int']>;
  productListItemByMasterIds: Array<Maybe<MasterProductListItem>>;
  productMasterIdByVariantId: Maybe<Scalars['String']>;
  /** @deprecated Use productDetailByMasterId */
  productsById: Maybe<Array<Maybe<Product>>>;
  productsPriceById: Maybe<Array<Maybe<ProductPrice>>>;
  productsPriceByIdAndShop: Maybe<Array<Maybe<ProductPrice>>>;
  resolveUrl: PathView;
  reviews: Array<Review>;
  reviewsSummary: ReviewSummary;
  samplingIsValidEmail: ValidEmail;
  shopSettings: Maybe<Shop>;
  tnbCampaign: Maybe<TnbCampaign>;
  tnbProductRecom: Array<Maybe<Scalars['String']>>;
  tnbProducts: Array<Maybe<TnBProduct>>;
  tnbSettings: TnbSettings;
  tnbToken: TnBToken;
  user: Maybe<User>;
  userProductsInfo: Maybe<Array<Maybe<UserProductInfo>>>;
  /** @deprecated Use userProductsInfo. Comparison price is determined by Product Id instead of Master Id as before. */
  userProductsInfoByMasterIds: Maybe<Array<Maybe<UserProductInfo>>>;
  validateText: ValidateTextResult;
  vpProductById: Maybe<VpProduct>;
  vpProductByIds: Array<Maybe<VpProduct>>;
  watchdogActive: WatchdogActive;
  watchdogs: Maybe<ClientWatchdogs>;
};

export type QueryAdminPanelInfoArgs = {
  productUrl: Scalars['String'];
};

export type QueryAvailableGiftsByCartContentArgs = {
  cartContent: GetShoppingCartContentProxyResponseModelInput;
  cartId: Scalars['String'];
  defaultAssign?: InputMaybe<Scalars['Boolean']>;
};

export type QueryAvailableGiftsByCartIdArgs = {
  cartId: Scalars['String'];
  defaultAssign?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCartServicesIncludedArgs = {
  productsIds: Scalars['String'];
};

export type QueryGiftGetActionCountriesArgs = {
  id: Scalars['Int'];
};

export type QueryGiftGetActionsArgs = {
  id: Scalars['Int'];
  shopId: Scalars['String'];
};

export type QueryRichContentAvailableArgs = {
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
};

export type QueryRichContentDataArgs = {
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
};

export type QueryRoutineByProductIdArgs = {
  productId?: InputMaybe<Scalars['String']>;
};

export type QueryRoutineItemArgs = {
  productId?: InputMaybe<Scalars['String']>;
};

export type QueryVpByProductIdArgs = {
  productId: Scalars['String'];
};

export type QueryWishlistByLoggedUserOrOwnerArgs = {
  owner?: InputMaybe<Scalars['String']>;
};

export type QueryWishlistByOwnerArgs = {
  owner: Scalars['String'];
};

export type QueryBrandArgs = {
  id: Scalars['Int'];
};

export type QueryCollectStoresByProductIdArgs = {
  productId: Scalars['Int'];
};

export type QueryEventCalendarByYearArgs = {
  type: Scalars['String'];
  year: Scalars['String'];
};

export type QueryFreetextArgs = {
  id: Scalars['String'];
};

export type QueryGetArticlesArgs = {
  variables: ArticlesQueryVariables;
};

export type QueryGetLivestreamsArgs = {
  variables: GetLivestreamVariables;
};

export type QueryGetRecommendedProductsArgs = {
  productCode: Scalars['String'];
};

export type QueryGetShadefinderArgs = {
  productId: Scalars['String'];
};

export type QueryGetUpsellingProductsArgs = {
  productCode: Scalars['String'];
};

export type QueryGetUpsellingProductsForMultipleArgs = {
  productCodes: Array<Scalars['String']>;
};

export type QueryIsValidEmailArgs = {
  email: Scalars['String'];
};

export type QueryLanguagedMessagesByPrefixesArgs = {
  prefixes?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryLoggedInUserReviewArgs = {
  masterProductCode: Scalars['String'];
};

export type QueryMissAlreadyVotedArgs = {
  year: Scalars['String'];
};

export type QueryMissVotedByEmailArgs = {
  email: Scalars['String'];
  year: Scalars['String'];
};

export type QueryModifaceHairLicenceByHostNameArgs = {
  hostName: Scalars['String'];
};

export type QueryModifaceLicenceByHostNameArgs = {
  hostName: Scalars['String'];
};

export type QueryProductArgs = {
  productUrl: Scalars['String'];
};

export type QueryProductBySCodeArgs = {
  sCode: Scalars['String'];
};

export type QueryProductDetailByMasterIdArgs = {
  masterId: Scalars['String'];
};

export type QueryProductDetailByStoreArgs = {
  masterId: Scalars['String'];
  storeCode: Scalars['String'];
};

export type QueryProductIdBySCodeArgs = {
  sCode: Scalars['String'];
};

export type QueryProductListItemByMasterIdsArgs = {
  masterIds: Array<Scalars['String']>;
};

export type QueryProductMasterIdByVariantIdArgs = {
  productId: Scalars['String'];
};

export type QueryProductsByIdArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryProductsPriceByIdArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryProductsPriceByIdAndShopArgs = {
  ids: Array<Scalars['String']>;
  shop?: InputMaybe<Scalars['String']>;
};

export type QueryResolveUrlArgs = {
  url: Scalars['String'];
};

export type QueryReviewsArgs = {
  code: Scalars['String'];
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
  orderBy: ReviewOrderBy;
  orderDesc: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type QueryReviewsSummaryArgs = {
  masterProductCode: Scalars['String'];
  ratingFloorType: RatingFloortype;
};

export type QuerySamplingIsValidEmailArgs = {
  campaignId: Scalars['String'];
  email: Scalars['String'];
};

export type QueryTnbCampaignArgs = {
  campaignId: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
};

export type QueryTnbProductRecomArgs = {
  samples: Array<InputMaybe<Scalars['String']>>;
};

export type QueryTnbTokenArgs = {
  tokenId?: InputMaybe<Scalars['String']>;
};

export type QueryUserProductsInfoArgs = {
  productIds: Array<Scalars['String']>;
};

export type QueryUserProductsInfoByMasterIdsArgs = {
  masterIds: Array<Scalars['String']>;
};

export type QueryValidateTextArgs = {
  text: Scalars['String'];
};

export type QueryVpProductByIdArgs = {
  id: Scalars['String'];
};

export type QueryVpProductByIdsArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryWatchdogActiveArgs = {
  productId: Scalars['String'];
};

export type QuickContact = {
  __typename?: 'QuickContact';
  contactInformationUrl: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  phoneNumbers: Maybe<Array<Maybe<Scalars['String']>>>;
  workingHours: Maybe<Scalars['String']>;
};

export type RcContentInput = {
  isApproved?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rich?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type Rating = {
  id?: InputMaybe<Scalars['Int']>;
  ratingType?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
};

export enum RatingFloortype {
  Cosmetics = 'Cosmetics',
  Health = 'Health',
  Parfums = 'Parfums',
}

export type RecentMinPrice = {
  __typename?: 'RecentMinPrice';
  currency: Maybe<Scalars['String']>;
  isActionEligible: Maybe<Scalars['Boolean']>;
  tax: Maybe<Scalars['Float']>;
  value: Maybe<Scalars['Float']>;
};

export type RecommendedPrice = {
  __typename?: 'RecommendedPrice';
  currency: Scalars['String'];
  isConverted: Scalars['Boolean'];
  tax: Scalars['Float'];
  value: Scalars['Float'];
};

export type RecommendedProduct = {
  __typename?: 'RecommendedProduct';
  available: Scalars['Boolean'];
  mainImage: Scalars['String'];
  productId: Scalars['Int'];
  swatchImage: Maybe<Scalars['String']>;
  variantName: Scalars['String'];
};

export type Review = {
  __typename?: 'Review';
  alreadyDisliked: Scalars['Boolean'];
  alreadyLiked: Scalars['Boolean'];
  authorType: AuthorType;
  createdDate: Scalars['String'];
  dislike: Scalars['Int'];
  id: Scalars['Int'];
  like: Scalars['Int'];
  originalShopId: Maybe<Scalars['String']>;
  score: Scalars['Int'];
  text: Maybe<Scalars['String']>;
  translatedFrom: Maybe<Scalars['String']>;
  userName: Scalars['String'];
};

export enum ReviewOrderBy {
  DateTime = 'DateTime',
  Favorite = 'Favorite',
  Rating = 'Rating',
}

export type ReviewOverview = {
  __typename?: 'ReviewOverview';
  count: Scalars['Int'];
  rating: Scalars['Float'];
  textReviewsCount: Scalars['Int'];
  translatedReviewsCount: Scalars['Int'];
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  id: Scalars['Int'];
  ratingType: Scalars['String'];
  score: Scalars['Int'];
};

export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  success: Maybe<Scalars['Boolean']>;
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  averageRating: Scalars['Float'];
  ratings: Array<ReviewRating>;
  score: Scalars['Int'];
  totalVotes: Scalars['Int'];
  votes: Maybe<Scalars['JSON']>;
};

export enum ReviewVoteType {
  Dislike = 'dislike',
  Like = 'like',
}

export type RichContentAvailability = {
  __typename?: 'RichContentAvailability';
  available: Scalars['Boolean'];
  richContentData: Maybe<RichContentData>;
};

export type RichContentAvailable = {
  __typename?: 'RichContentAvailable';
  available: Scalars['Boolean'];
};

export type RichContentData = {
  __typename?: 'RichContentData';
  data: Maybe<Scalars['JSON']>;
};

export enum Roles {
  Admin = 'Admin',
  Anonymous = 'Anonymous',
  Customer = 'Customer',
  Superuser = 'Superuser',
}

export enum RolloutStatusType {
  Approved = 'approved',
  NotSet = 'notSet',
  Rejected = 'rejected',
}

export type Route = {
  __typename?: 'Route';
  component: Maybe<Scalars['String']>;
  exact: Maybe<Scalars['Boolean']>;
  path: Maybe<Scalars['String']>;
  rolesOnly: Maybe<Array<Maybe<Roles>>>;
};

export type Routine = {
  __typename?: 'Routine';
  created: Maybe<Scalars['String']>;
  header: Maybe<RoutineHeader>;
  id: Scalars['ID'];
  isActive: Maybe<Scalars['Boolean']>;
  items: Maybe<Array<Maybe<RoutineItem>>>;
  ownerName: Maybe<Scalars['String']>;
  shops: Maybe<Array<Maybe<Scalars['String']>>>;
  updated: Maybe<Scalars['String']>;
};

export type RoutineAsset = {
  __typename?: 'RoutineAsset';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
  type: Maybe<RoutineAssetEnum>;
};

export enum RoutineAssetEnum {
  Image = 'Image',
  Video = 'Video',
}

export type RoutineAvailability = {
  __typename?: 'RoutineAvailability';
  available: Scalars['Boolean'];
  routine: Maybe<Routine>;
};

export type RoutineHeader = {
  __typename?: 'RoutineHeader';
  asset: Maybe<RoutineAsset>;
  description: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type RoutineItem = {
  __typename?: 'RoutineItem';
  description: Maybe<Scalars['String']>;
  isBinding: Maybe<Scalars['Boolean']>;
  isTemplate: Maybe<Scalars['Boolean']>;
  order: Maybe<Scalars['Int']>;
  product: Maybe<VpProduct>;
  productCode: Maybe<Scalars['String']>;
  productId: Scalars['Int'];
};

export type SamplingCustomer = {
  __typename?: 'SamplingCustomer';
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

export type SamplingOrderResponse = {
  __typename?: 'SamplingOrderResponse';
  campaignId: Maybe<Scalars['String']>;
  customer: Maybe<SamplingCustomer>;
  id: Maybe<Scalars['String']>;
  shopId: Maybe<Scalars['String']>;
};

export enum SectionType {
  Other = 'Other',
  UpcomingHolidays = 'UpcomingHolidays',
  WhyShopAtNotino = 'WhyShopAtNotino',
}

export type Seo = {
  __typename?: 'Seo';
  description: Maybe<Scalars['String']>;
  keywords: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type ServiceDto = {
  __typename?: 'ServiceDto';
  cartItemId: Maybe<Scalars['Int']>;
  cartServiceItem: Maybe<Scalars['Int']>;
  groupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  ident: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  serviceName: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type ServiceItemsDto = {
  __typename?: 'ServiceItemsDto';
  ecoPackaging: Maybe<CartContentProduct>;
  fundRaising: Maybe<CartContentProduct>;
  giftPackagings: Array<CartContentProduct>;
  insurance: Maybe<CartContentProduct>;
};

export type ServicesIncluded = {
  __typename?: 'ServicesIncluded';
  engravingShow: Scalars['Boolean'];
  tryFirstShow: Scalars['Boolean'];
};

export type Settings = {
  __typename?: 'Settings';
  cloudflareSettings: Maybe<Cloudflare>;
  deliveriesDisplayMode: Maybe<Scalars['String']>;
  featureSwitches: Maybe<FeatureSwitches>;
  imageDomainPath: Scalars['String'];
  isAddToCartButtonAllowed: Maybe<Scalars['String']>;
  isAddToCartModalAllowed: Maybe<Scalars['String']>;
  isEngravingAllowed: Maybe<Scalars['String']>;
  isNewShoppingCartEndpointEnabled: Maybe<Scalars['Boolean']>;
  isRoutineAllowed: Maybe<Scalars['String']>;
  isWishlistAllowed: Maybe<Scalars['Boolean']>;
  /** @deprecated Configurable fields are no longer necessary due to url-resolver. */
  routes: Array<Maybe<Route>>;
  showUnitPrices: Maybe<Scalars['Boolean']>;
};

export type Shade = {
  __typename?: 'Shade';
  bright: Maybe<Undertones>;
  dark: Maybe<Undertones>;
  medium: Maybe<Undertones>;
  mediumDark: Maybe<Undertones>;
  ultraBright: Maybe<Undertones>;
};

export type ShadefinderResponse = {
  __typename?: 'ShadefinderResponse';
  available: Scalars['Boolean'];
  shades: Shade;
};

export type Shop = {
  __typename?: 'Shop';
  countryCode: Scalars['String'];
  defaultCurrency: DefaultCurrency;
  defaultLanguage: Language;
  gdprSettings: GdprSettings;
  shopId: Scalars['String'];
  websiteId: Scalars['Int'];
};

export type ShoppingCartModel = {
  __typename?: 'ShoppingCartModel';
  availableGifts: Maybe<Array<Maybe<AssignModel>>>;
  boxes: Maybe<ShoppingCartModel_Boxes>;
  cartId: Maybe<Scalars['String']>;
  delivery: Maybe<CartItemDto>;
  insurance: Maybe<CartItemDto>;
  items: Maybe<Array<Maybe<CartItemDto>>>;
  payment: Maybe<CartItemDto>;
  services: Maybe<Array<Maybe<ServiceDto>>>;
};

export type ShoppingCartModel_Boxes = {
  __typename?: 'ShoppingCartModel_boxes';
  /** default field */
  success: Maybe<Scalars['String']>;
};

export type SocialIcon = {
  __typename?: 'SocialIcon';
  link: Maybe<Scalars['String']>;
  name: Maybe<SocialIconName>;
};

export enum SocialIconName {
  Blog = 'Blog',
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  Twitter = 'Twitter',
  YouTube = 'YouTube',
}

export type Sorter = {
  __typename?: 'Sorter';
  desc: Maybe<Scalars['Boolean']>;
  sortBy: Maybe<Scalars['String']>;
};

export type SorterInput = {
  desc: Scalars['Boolean'];
  sortBy: Scalars['String'];
};

export enum StockAvailability {
  Last1 = 'Last1',
  Last2 = 'Last2',
  Last3 = 'Last3',
  Last4 = 'Last4',
  Last5 = 'Last5',
  MoreThan5 = 'MoreThan5',
  MoreThan20 = 'MoreThan20',
  OutOfStock = 'OutOfStock',
}

export type StockInfo = {
  __typename?: 'StockInfo';
  code: Maybe<Scalars['String']>;
  count: Maybe<Scalars['Int']>;
};

export type Store = {
  __typename?: 'Store';
  name: Maybe<Scalars['String']>;
  urlPath: Maybe<Scalars['String']>;
};

export type StoreProduct = {
  __typename?: 'StoreProduct';
  annotation: Maybe<Scalars['String']>;
  brandInfo: Maybe<Brand>;
  breadcrumb: Maybe<Array<Maybe<Breadcrumb>>>;
  categorization: Categorization;
  code: Maybe<Scalars['String']>;
  collection: Maybe<Scalars['String']>;
  composition: Maybe<Array<Maybe<Characteristic>>>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: Maybe<Scalars['String']>;
  masterCode: Maybe<Scalars['String']>;
  related: Maybe<Array<Maybe<Scalars['Int']>>>;
  reviewOverview: Maybe<ReviewOverview>;
  subName: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  variantDisplayType: Maybe<VariantDisplayType>;
  variants: Maybe<Array<Maybe<Variant>>>;
};

export enum SubjectType {
  BrandDiscount = 'BrandDiscount',
  CategoryDiscount = 'CategoryDiscount',
}

export type Subscription = {
  __typename?: 'Subscription';
  dummy: Maybe<Scalars['String']>;
};

export type TableManipulatorInput = {
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  pager: PagerInput;
  sorter?: InputMaybe<SorterInput>;
};

export type TnBProduct = {
  __typename?: 'TnBProduct';
  accord: Maybe<Scalars['String']>;
  brand: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  group: Maybe<Array<Maybe<Scalars['String']>>>;
  img: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type TnBToken = {
  __typename?: 'TnBToken';
  id: Maybe<Scalars['String']>;
  orderId: Maybe<Scalars['String']>;
  product: Maybe<TnBTokenProduct>;
  status: Maybe<Scalars['String']>;
};

export type TnBTokenProduct = {
  __typename?: 'TnBTokenProduct';
  orderCode: Maybe<Scalars['String']>;
};

export type TnbCampaign = {
  __typename?: 'TnbCampaign';
  closeAfterItemSelect: Maybe<Scalars['Boolean']>;
  displayMarketingConsent: Maybe<Scalars['Boolean']>;
  enableMultiOpenPicker: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['Int']>;
  isActive: Maybe<Scalars['Boolean']>;
  isFirstPickerOpened: Maybe<Scalars['Boolean']>;
  isMarketingConsentRequired: Maybe<Scalars['Boolean']>;
  isSmsValidationOn: Maybe<Scalars['Boolean']>;
  isTresholdReached: Maybe<Scalars['Boolean']>;
  items: Maybe<Array<Maybe<TnbItem>>>;
  minOrderCount: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  pickerItemComponentType: Maybe<Scalars['Int']>;
  sampleCount: Maybe<Scalars['Int']>;
  sendConfirmationEmail: Maybe<Scalars['Boolean']>;
  shopId: Maybe<Scalars['String']>;
  thankYouImage: Maybe<Scalars['String']>;
};

export type TnbItem = {
  __typename?: 'TnbItem';
  additionalInfo: Maybe<Scalars['String']>;
  additionalText: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  customDisplayText: Maybe<Scalars['String']>;
  customImageUrl: Maybe<Scalars['String']>;
  displayOrder: Maybe<Scalars['Int']>;
  images: Maybe<Array<Maybe<TnbItemImage>>>;
  name: Maybe<Scalars['String']>;
  orderCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  useCustomImage: Maybe<Scalars['Boolean']>;
  useCustomText: Maybe<Scalars['Boolean']>;
  variantName: Maybe<Scalars['String']>;
};

export type TnbItemImage = {
  __typename?: 'TnbItemImage';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
};

export type TnbMakeOrderResponse = {
  __typename?: 'TnbMakeOrderResponse';
  emailIsUsed: Maybe<Scalars['Boolean']>;
  error: Maybe<Scalars['String']>;
  phoneIsUsed: Maybe<Scalars['Boolean']>;
  success: Maybe<Scalars['Boolean']>;
};

export type Undertones = {
  __typename?: 'Undertones';
  cold: Maybe<DesiredShade>;
  neutral: Maybe<DesiredShade>;
  warm: Maybe<DesiredShade>;
};

export type UnitPrice = {
  __typename?: 'UnitPrice';
  perAmount: Maybe<Scalars['Int']>;
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type UnitPriceDetail = {
  __typename?: 'UnitPriceDetail';
  currency: Maybe<Scalars['String']>;
  perAmount: Maybe<Scalars['Int']>;
  tax: Maybe<Scalars['Float']>;
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  cartId: Maybe<Scalars['String']>;
  comparisonIds: Maybe<Scalars['String']>;
  consent: Array<Scalars['String']>;
  grd: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  info: Maybe<UserInfo>;
  role: Maybe<Roles>;
  token: Maybe<Scalars['String']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  lastName: Maybe<Scalars['String']>;
  lastName2: Maybe<Scalars['String']>;
};

export type UserProductInfo = {
  __typename?: 'UserProductInfo';
  isComparison: Maybe<Scalars['Boolean']>;
  productId: Maybe<Scalars['String']>;
};

export type VpAsset = {
  __typename?: 'VPAsset';
  alt: Maybe<Scalars['String']>;
  src: Maybe<Scalars['String']>;
  type: Maybe<VpAssetEnum>;
};

export enum VpAssetEnum {
  Image = 'Image',
  Video = 'Video',
}

export type VpAvailability = {
  __typename?: 'VPAvailability';
  available: Scalars['Boolean'];
  virtualPackage: Maybe<VpCampaign>;
};

export type VpCampaign = {
  __typename?: 'VPCampaign';
  availableFrom: Maybe<Scalars['String']>;
  availableTo: Maybe<Scalars['String']>;
  created: Maybe<Scalars['String']>;
  discount: Maybe<Scalars['Float']>;
  header: Maybe<VpHeader>;
  id: Scalars['ID'];
  isActive: Maybe<Scalars['Boolean']>;
  isHidden: Maybe<Scalars['Boolean']>;
  items: Maybe<Array<Maybe<VpItem>>>;
  ownerName: Maybe<Scalars['String']>;
  shops: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Maybe<VirtualPackageStatus>;
  updated: Maybe<Scalars['String']>;
};

export type VpCampaignName = {
  __typename?: 'VPCampaignName';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  texts: Maybe<Array<Maybe<VpCampaignNameTexts>>>;
};

export type VpCampaignNameTexts = {
  __typename?: 'VPCampaignNameTexts';
  id: Maybe<Scalars['String']>;
  shopName: Maybe<Scalars['String']>;
  text: Maybe<Scalars['String']>;
};

export type VpHeader = {
  __typename?: 'VPHeader';
  asset: Maybe<VpAsset>;
  description: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  workingTitle: Maybe<Scalars['String']>;
};

export type VpItem = {
  __typename?: 'VPItem';
  isBinding: Maybe<Scalars['Boolean']>;
  isTemplate: Maybe<Scalars['Boolean']>;
  order: Maybe<Scalars['Int']>;
  product: Maybe<VpProduct>;
  productCode: Maybe<Scalars['String']>;
  productId: Scalars['Int'];
  reasonsNotToShowProduct: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ValidEmail = {
  __typename?: 'ValidEmail';
  isValidEmail: Scalars['Boolean'];
};

export type ValidateTextResult = {
  __typename?: 'ValidateTextResult';
  forbiddenWords: Maybe<Array<Maybe<Scalars['String']>>>;
  status: Maybe<Scalars['String']>;
};

export type Variant = ProductVariantCoreInfo & {
  __typename?: 'Variant';
  additionalInfo: Maybe<Scalars['String']>;
  additionalText: Maybe<Scalars['String']>;
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  availablePickUpStores: Maybe<Scalars['Int']>;
  campaignConfig: Maybe<CampaignConfig>;
  canBuy: Maybe<Scalars['Boolean']>;
  characteristics: Maybe<Array<Maybe<Characteristic>>>;
  color: Maybe<Scalars['String']>;
  colors: Maybe<Array<Maybe<Scalars['String']>>>;
  customerBenefits: Maybe<VariantCustomerBenefits>;
  descriptionOverride: Maybe<Scalars['String']>;
  eanCode: Maybe<Scalars['String']>;
  engraving: Maybe<Engraving>;
  gender: Maybe<Scalars['String']>;
  /** @deprecated Use campaignConfig. */
  giftPackagingConfig: Maybe<GiftPackagingConfig>;
  hairModifaceEffects: Maybe<Array<Maybe<HairModifaceEffects>>>;
  id: Maybe<Scalars['ID']>;
  images: Maybe<Array<Maybe<Image>>>;
  imagesByCategory: Maybe<ImagesByCategory>;
  legalInformation: Maybe<LegalInformation>;
  maxOrderQty: Maybe<Scalars['Int']>;
  /** @deprecated Use modifaceData which contains more data for modiface */
  modifaceEffects: Maybe<Array<Maybe<ModifaceEffect>>>;
  modifaceMakeUpData: Maybe<Array<Maybe<Scalars['JSON']>>>;
  name: Maybe<Scalars['String']>;
  navigationValues: Maybe<Array<Maybe<Scalars['Int']>>>;
  nextDeliveryDate: Maybe<Scalars['String']>;
  orderCode: Maybe<Scalars['String']>;
  originalPrice: Maybe<OriginalPrice>;
  parameters: Maybe<Parameters>;
  price: Maybe<Price>;
  primaryCategories: PrimaryCategories;
  productCode: Maybe<Scalars['String']>;
  recentMinPrice: Maybe<RecentMinPrice>;
  seo: Maybe<Seo>;
  showWatchdog: Maybe<Scalars['Boolean']>;
  stockAvailability: Maybe<StockInfo>;
  type: Maybe<Scalars['String']>;
  unitPrice: Maybe<UnitPriceDetail>;
  url: Maybe<Scalars['String']>;
  variantName: Maybe<Scalars['String']>;
  videos: Maybe<Array<Maybe<Scalars['String']>>>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type VariantCustomerBenefits = {
  __typename?: 'VariantCustomerBenefits';
  availableDiscount: Maybe<Discount>;
  customerDiscount: Maybe<Discount>;
};

export enum VariantDisplayType {
  ColorPicker = 'ColorPicker',
  Default = 'Default',
  Select = 'Select',
  ShadesDrawer = 'ShadesDrawer',
  Thumbnail = 'Thumbnail',
  Tiles = 'Tiles',
}

export enum VirtualPackageStatus {
  Approved = 'Approved',
  CanceledByUser = 'CanceledByUser',
  Disapproved = 'Disapproved',
  Finished = 'Finished',
  New = 'New',
  Published = 'Published',
  WaitingForApproval = 'WaitingForApproval',
}

export type VitaminsAndMinerals = {
  __typename?: 'VitaminsAndMinerals';
  amount: Maybe<Scalars['Float']>;
  amountSign: Maybe<Scalars['String']>;
  measureUnit: Maybe<Scalars['String']>;
  nutritionValue: Maybe<Scalars['String']>;
  onePortionAmount: Maybe<Scalars['Float']>;
  referenceValue: Maybe<Scalars['Float']>;
  referenceValueOnePercent: Maybe<Scalars['Float']>;
  referenceValuePercent: Maybe<Scalars['Float']>;
};

export enum VoteAction {
  Add = 'add',
  Remove = 'remove',
}

export enum VoteType {
  Dislike = 'dislike',
  Like = 'like',
}

export type VoucherDto = {
  __typename?: 'VoucherDto';
  deleted: Scalars['Boolean'];
  isDeliveryVoucher: Scalars['Boolean'];
  isPercentVoucher: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type VpProduct = ProductVariantCoreInfo & {
  __typename?: 'VpProduct';
  annotation: Maybe<Scalars['String']>;
  attributes: Maybe<Scalars['JSON']>;
  brand: Maybe<Brand>;
  canBuy: Scalars['Boolean'];
  config: ProductConfig;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  imageUrl: Maybe<Scalars['String']>;
  masterId: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  orderUnit: Maybe<Scalars['String']>;
  price: Maybe<Price>;
  primaryCategories: PrimaryCategories;
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['Int']>;
  recommendedPrice: Maybe<RecommendedPrice>;
  reviewOverview: Maybe<ReviewOverview>;
  /** @deprecated Use reviewOverview. */
  reviewSummary: Maybe<ReviewSummary>;
  showWatchdog: Scalars['Boolean'];
  stockAvailability: Maybe<StockInfo>;
  subName: Maybe<Scalars['String']>;
  unitPrice: Maybe<UnitPrice>;
  url: Maybe<Scalars['String']>;
  wishlisted: Maybe<Scalars['Boolean']>;
};

export type WatchDog = {
  __typename?: 'WatchDog';
  errors: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type WatchdogActive = {
  __typename?: 'WatchdogActive';
  watchdogActive: Scalars['Boolean'];
};

export type Wishlist = {
  __typename?: 'Wishlist';
  id: Scalars['ID'];
  owner: Scalars['String'];
  products: Array<Maybe<Scalars['String']>>;
};

export type WishlistId = {
  __typename?: 'WishlistId';
  id: Scalars['ID'];
};

export type TnbMakeOrderInput = {
  acceptedNewsletterOffer?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  productIds: Array<Scalars['Int']>;
  sendConfirmationEmail?: InputMaybe<Scalars['Boolean']>;
  smsCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type TnbOrderInput = {
  customer: CustomerInput;
  samples: Array<InputMaybe<Scalars['String']>>;
  token: Scalars['String'];
};

export type TnbOrderResponse = {
  __typename?: 'tnbOrderResponse';
  orderNumber: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TnbSettings = {
  __typename?: 'tnbSettings';
  defaultGender: Scalars['String'];
  defaultGroup: Scalars['String'];
  phoneRegex: Scalars['String'];
  shopId: Scalars['String'];
  zipRegex: Scalars['String'];
};

export type TnbSmsValidationInput = {
  campaignId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type GetImageSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetImageSettingsQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type UpdatePathnameQueryVariables = Exact<{ [key: string]: never }>;

export type UpdatePathnameQuery = {
  __typename?: 'Query';
  ProductSsrData: {
    __typename?: 'ClientProductSsr';
    pathname: string | null;
    productId: string | null;
    type: string | null;
  } | null;
};

export type UpdateResolveUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;

export type UpdateResolveUrlQuery = {
  __typename?: 'Query';
  resolveUrl: {
    __typename: 'PathView';
    id: string;
    path: string;
    type: PathTemplate;
    productId: string | null;
  };
};

export type GetLivestreamsQueryVariables = Exact<{
  variables: GetLivestreamVariables;
}>;

export type GetLivestreamsQuery = {
  __typename?: 'Query';
  getLivestreams: {
    __typename?: 'GetLivestreamResponse';
    shows: Array<{
      __typename?: 'Livestream';
      showId: string;
      title: string;
      description: string;
      previewImageUrl: string;
      videoLength: string;
      isLive: boolean;
      scheduledStart: string | null;
      scheduledDate: string;
      publishedDate: string | null;
      deeplink: string;
    }> | null;
  } | null;
};

export type GetPriceConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetPriceConfigQuery = {
  __typename?: 'Query';
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
};

export type GetProductsByIdBatchedQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetProductsByIdBatchedQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: { __typename?: 'ReviewOverview'; rating: number } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      subCategory: string;
      kind: string;
      type: string;
    };
  } | null>;
};

export type FragmentVpProductByIdBodyModifiedFragment = {
  __typename?: 'VpProduct';
  id: string | null;
  masterId: number | null;
  url: string | null;
  imageUrl: string | null;
  name: string | null;
  subName: string | null;
  annotation: string | null;
  productCode: string | null;
  wishlisted: boolean | null;
  attributes: any | null;
  showWatchdog: boolean;
  canBuy: boolean;
  price: {
    __typename?: 'Price';
    value: number | null;
    currency: string | null;
    tax: number | null;
  } | null;
  config: {
    __typename?: 'ProductConfig';
    showAddToCartModal: boolean | null;
    showAddToCartButton: boolean | null;
  };
  brand: { __typename?: 'Brand'; name: string } | null;
  stockAvailability: {
    __typename?: 'StockInfo';
    code: string | null;
    count: number | null;
  } | null;
  unitPrice: {
    __typename?: 'UnitPrice';
    value: number | null;
    unit: string | null;
    perAmount: number | null;
  } | null;
  reviewOverview: { __typename?: 'ReviewOverview'; rating: number } | null;
  primaryCategories: {
    __typename?: 'PrimaryCategories';
    category: string;
    subCategory: string;
    kind: string;
    type: string;
  };
};

export type GetItemDataByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetItemDataByIdQuery = {
  __typename?: 'Query';
  vpProductById: {
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: { __typename?: 'ReviewOverview'; rating: number } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      subCategory: string;
      kind: string;
      type: string;
    };
  } | null;
};

export type AddToWishlistMutationVariables = Exact<{
  productId: Scalars['String'];
}>;

export type AddToWishlistMutation = {
  __typename?: 'Mutation';
  WishlistAddProduct: {
    __typename?: 'Wishlist';
    id: string;
    products: Array<string | null>;
  } | null;
};

export type IsWishlistEnabledQueryVariables = Exact<{ [key: string]: never }>;

export type IsWishlistEnabledQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; isWishlistAllowed: boolean | null };
};

export type RemoveFromWishlistMutationVariables = Exact<{
  productId: Scalars['String'];
}>;

export type RemoveFromWishlistMutation = {
  __typename?: 'Mutation';
  WishlistRemoveProduct: {
    __typename?: 'Wishlist';
    id: string;
    products: Array<string | null>;
  } | null;
};

export type GetProductPathNameQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductPathNameQuery = {
  __typename?: 'Query';
  ProductSsrData: {
    __typename?: 'ClientProductSsr';
    pathname: string | null;
  } | null;
};

export type GetProductWebViewQueryVariables = Exact<{
  url: Scalars['String'];
}>;

export type GetProductWebViewQuery = {
  __typename?: 'Query';
  resolveUrl: {
    __typename: 'PathView';
    id: string;
    path: string;
    type: PathTemplate;
    productId: string | null;
  };
};

export type AdminPanelInfoBodyFragment = {
  __typename?: 'AdminPanelInfo';
  approvalStatus: RolloutStatusType | null;
  message: string | null;
  displayType: string | null;
  availableShops: Array<{
    __typename?: 'AvailableShop';
    productUrl: string;
    shopId: string;
    languageTag: string;
  }> | null;
};

export type GetAdminInfoQueryVariables = Exact<{
  productUrl: Scalars['String'];
}>;

export type GetAdminInfoQuery = {
  __typename?: 'Query';
  AppConfig: {
    __typename?: 'AppConfig';
    supportedLocales: Array<string> | null;
  };
  AdminPanelInfo: {
    __typename?: 'AdminPanelInfo';
    approvalStatus: RolloutStatusType | null;
    message: string | null;
    displayType: string | null;
    availableShops: Array<{
      __typename?: 'AvailableShop';
      productUrl: string;
      shopId: string;
      languageTag: string;
    }> | null;
  } | null;
};

export type GetRequestHeadersShopIdQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetRequestHeadersShopIdQuery = {
  __typename?: 'Query';
  RequestHeaders: { __typename?: 'ClientHeaders'; shopId: string } | null;
};

export type GetEventCalendarByYearQueryVariables = Exact<{
  type: Scalars['String'];
  year: Scalars['String'];
}>;

export type GetEventCalendarByYearQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
  eventCalendarByYear: Array<{
    __typename?: 'EventCalendarDay';
    date: string | null;
    url: string | null;
    title: string | null;
    description: string | null;
    giftAvailable: boolean | null;
    smallImage: string | null;
    largeImage: string | null;
    filterType: string | null;
    filterId: Array<number | null> | null;
    buttonText: string | null;
    todayItem: boolean | null;
    brand: {
      __typename?: 'Brand';
      id: string;
      name: string;
      logoUrl: string | null;
      url: string | null;
    } | null;
    brands: Array<{
      __typename?: 'Brand';
      id: string;
      name: string;
      logoUrl: string | null;
      url: string | null;
    } | null> | null;
  } | null>;
  user: { __typename?: 'User'; id: string | null; role: Roles | null } | null;
};

export type GetLocalesDataQueryVariables = Exact<{
  prefixes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetLocalesDataQuery = {
  __typename?: 'Query';
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
  languagedMessagesByPrefixes: {
    __typename?: 'LanguagedMessage';
    acceptLanguage: string;
    messages: any | null;
  };
};

export type MissAlreadyVotedQueryVariables = Exact<{
  year: Scalars['String'];
}>;

export type MissAlreadyVotedQuery = {
  __typename?: 'Query';
  missAlreadyVoted: {
    __typename?: 'MissAlreadyVoted';
    voted: boolean | null;
    facebookAppId: string | null;
    user: {
      __typename?: 'User';
      grd: string | null;
      info: {
        __typename?: 'UserInfo';
        firstName: string | null;
        email: string | null;
      } | null;
    } | null;
  } | null;
};

export type MissSaveVoteMutationVariables = Exact<{
  year: Scalars['String'];
  voteInput: MissVoteInput;
}>;

export type MissSaveVoteMutation = {
  __typename?: 'Mutation';
  missSaveVote: {
    __typename?: 'MissVotePayload';
    status: MissVoteStatus | null;
    data: string | null;
  } | null;
};

export type GetBlogArticlesQueryVariables = Exact<{
  variables: ArticlesQueryVariables;
}>;

export type GetBlogArticlesQuery = {
  __typename?: 'Query';
  getArticles: {
    __typename?: 'ArticlesQueryResponse';
    articles: Array<{
      __typename?: 'BlogArticle';
      title: string;
      url: string;
      hreflangId: string | null;
      image: {
        __typename?: 'BlogArticleImage';
        url: string | null;
        alt: string | null;
      } | null;
    }>;
  } | null;
};

export type GetModifaceDomainQueryVariables = Exact<{ [key: string]: never }>;

export type GetModifaceDomainQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    modifaceDomain: string | null;
  } | null;
};

export type ModifaceHairLicenceByHostNameQueryVariables = Exact<{
  hostName: Scalars['String'];
}>;

export type ModifaceHairLicenceByHostNameQuery = {
  __typename?: 'Query';
  modifaceHairLicenceByHostName: string;
};

export type ModifaceLicenceByHostNameQueryVariables = Exact<{
  hostName: Scalars['String'];
}>;

export type ModifaceLicenceByHostNameQuery = {
  __typename?: 'Query';
  modifaceLicenceByHostName: string;
};

export type AddToClickAndCollectMutationVariables = Exact<{
  warehouseCode: Scalars['String'];
  productId: Scalars['Int'];
}>;

export type AddToClickAndCollectMutation = {
  __typename?: 'Mutation';
  addProductToClickAndCollect: {
    __typename?: 'ShoppingCartModel';
    cartId: string | null;
  } | null;
};

export type GetStoresQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;

export type GetStoresQuery = {
  __typename?: 'Query';
  collectStoresByProductId: Array<{
    __typename?: 'ClickAndCollectStore';
    name: string;
    code: string;
    description: string;
    stockCount: StockAvailability;
    earliestPickup: string;
  }> | null;
};

export type GetUserLoyaltyProgressQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserLoyaltyProgressQuery = {
  __typename?: 'Query';
  isUserSubscribed: boolean;
  user: { __typename?: 'User'; id: string | null; role: Roles | null } | null;
};

export type GetCustomerBenefitsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerBenefitsQuery = {
  __typename?: 'Query';
  customerBenefits: {
    __typename?: 'CustomerBenefits';
    hasActiveBenefits: boolean | null;
    brandDiscountLimit: number | null;
    categoryDiscountLimit: number | null;
    brandDiscounts: Array<{
      __typename?: 'CustomerBenefitsDiscount';
      value: number | null;
      type: string | null;
      subjectName: string | null;
    } | null> | null;
    categoryDiscounts: Array<{
      __typename?: 'CustomerBenefitsDiscount';
      value: number | null;
      type: string | null;
      subjectName: string | null;
    } | null> | null;
  } | null;
};

export type GetShadefinderAppIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetShadefinderAppIdQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    shadefinderAppId: string | null;
  } | null;
};

export type GetShadefinderQueryQueryVariables = Exact<{
  productId: Scalars['String'];
}>;

export type GetShadefinderQueryQuery = {
  __typename?: 'Query';
  getShadefinder: {
    __typename?: 'ShadefinderResponse';
    available: boolean;
    shades: {
      __typename?: 'Shade';
      ultraBright: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      bright: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      medium: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      mediumDark: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
      dark: {
        __typename?: 'Undertones';
        cold: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        neutral: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
        warm: {
          __typename?: 'DesiredShade';
          darker: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          ideal: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
          lighter: {
            __typename?: 'RecommendedProduct';
            available: boolean;
            productId: number;
            mainImage: string;
            swatchImage: string | null;
            variantName: string;
          } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type UndertoneFragmentFragment = {
  __typename?: 'Undertones';
  cold: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
  neutral: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
  warm: {
    __typename?: 'DesiredShade';
    darker: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    ideal: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
    lighter: {
      __typename?: 'RecommendedProduct';
      available: boolean;
      productId: number;
      mainImage: string;
      swatchImage: string | null;
      variantName: string;
    } | null;
  } | null;
};

export type GetShopIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetShopIdQuery = {
  __typename?: 'Query';
  RequestHeaders: { __typename?: 'ClientHeaders'; shopId: string } | null;
};

export type AddToCartTryFirstMutationVariables = Exact<{
  productCode: Scalars['String'];
  productId: Scalars['String'];
  tryItFirstId: Scalars['String'];
}>;

export type AddToCartTryFirstMutation = {
  __typename?: 'Mutation';
  TryItFirstAddToCart: {
    __typename?: 'AddToCartTryItFirstResult';
    status: Array<CartProductStatus> | null;
  };
};

export type ProductInfoQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type ProductInfoQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    collection: string | null;
    annotation: string | null;
    variants: Array<{
      __typename?: 'Variant';
      attributes: any | null;
      imagesByCategory: {
        __typename?: 'ImagesByCategory';
        mainImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        };
      } | null;
    } | null> | null;
    brandInfo: { __typename?: 'Brand'; name: string } | null;
  } | null> | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type GetUserNameQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserNameQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    userName: string | null;
  } | null;
};

export type AddReviewMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<InputMaybe<Rating>> | InputMaybe<Rating>>;
  score: Scalars['Int'];
  name: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  source: Scalars['String'];
  digests?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
}>;

export type AddReviewMutation = {
  __typename?: 'Mutation';
  addReview: { __typename?: 'ReviewResponse'; success: boolean | null } | null;
};

export type HandleVoteMutationVariables = Exact<{
  id: Scalars['String'];
  type: VoteType;
  action: VoteAction;
}>;

export type HandleVoteMutation = {
  __typename?: 'Mutation';
  handleVote: {
    __typename?: 'Review';
    id: number;
    like: number;
    dislike: number;
    alreadyLiked: boolean;
    alreadyDisliked: boolean;
  } | null;
};

export type GetRichContentDataByKeyQueryVariables = Exact<{
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
}>;

export type GetRichContentDataByKeyQuery = {
  __typename?: 'Query';
  RichContentData: {
    __typename?: 'RichContentAvailability';
    available: boolean;
    richContentData: {
      __typename?: 'RichContentData';
      data: any | null;
    } | null;
  };
};

export type GetAvailabilityAndPriceQueryQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetAvailabilityAndPriceQueryQuery = {
  __typename?: 'Query';
  vpProductById: {
    __typename?: 'VpProduct';
    id: string | null;
    productCode: string | null;
    name: string | null;
    annotation: string | null;
    masterId: number | null;
    wishlisted: boolean | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    price: {
      __typename?: 'Price';
      currency: string | null;
      value: number | null;
      tax: number | null;
    } | null;
    brand: { __typename?: 'Brand'; name: string } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      kind: string;
      subCategory: string;
      type: string;
    };
    recommendedPrice: {
      __typename?: 'RecommendedPrice';
      isConverted: boolean;
      value: number;
      currency: string;
      tax: number;
    } | null;
  } | null;
};

export type GetAvailabilityAndPriceQueryBatchedQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetAvailabilityAndPriceQueryBatchedQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    productCode: string | null;
    name: string | null;
    annotation: string | null;
    masterId: number | null;
    wishlisted: boolean | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    price: {
      __typename?: 'Price';
      currency: string | null;
      value: number | null;
      tax: number | null;
    } | null;
    brand: { __typename?: 'Brand'; name: string } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      kind: string;
      subCategory: string;
      type: string;
    };
    recommendedPrice: {
      __typename?: 'RecommendedPrice';
      isConverted: boolean;
      value: number;
      currency: string;
      tax: number;
    } | null;
  } | null>;
};

export type HasWebcamQueryVariables = Exact<{ [key: string]: never }>;

export type HasWebcamQuery = {
  __typename?: 'Query';
  ClientCache: { __typename?: 'ClientCache'; hasWebcam: boolean | null } | null;
};

export type GetSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSettingsQuery = {
  __typename?: 'Query';
  Settings: {
    __typename?: 'Settings';
    isNewShoppingCartEndpointEnabled: boolean | null;
    showUnitPrices: boolean | null;
  };
};

export type GetRecommendedProductsQueryVariables = Exact<{
  productCode: Scalars['String'];
}>;

export type GetRecommendedProductsQuery = {
  __typename?: 'Query';
  databreakersRecommendedProducts: Array<string>;
};

export type GetRecaptchaSiteKeyQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecaptchaSiteKeyQuery = {
  __typename?: 'Query';
  AppConfig: { __typename?: 'AppConfig'; recaptchaSiteKey: string };
};

export type GetLoadingProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetLoadingProductQuery = {
  __typename?: 'Query';
  vpProductById: {
    __typename?: 'VpProduct';
    id: string | null;
    masterId: number | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    subName: string | null;
    annotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPrice';
      value: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    reviewOverview: { __typename?: 'ReviewOverview'; rating: number } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      subCategory: string;
      kind: string;
      type: string;
    };
  } | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type GetReviewOverviewQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type GetReviewOverviewQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    id: string;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      count: number;
      rating: number;
    } | null;
  } | null> | null;
};

export type GetRichContentAvailableQueryVariables = Exact<{
  rcKey: Scalars['String'];
  versionKey?: InputMaybe<Scalars['String']>;
}>;

export type GetRichContentAvailableQuery = {
  __typename?: 'Query';
  RichContentAvailable: {
    __typename?: 'RichContentAvailable';
    available: boolean;
  };
};

export type GetSectionsAvailabilityQueryVariables = Exact<{
  productId: Scalars['String'];
}>;

export type GetSectionsAvailabilityQuery = {
  __typename?: 'Query';
  RoutineByProductId: {
    __typename?: 'RoutineAvailability';
    available: boolean;
    routine: {
      __typename?: 'Routine';
      id: string;
      header: {
        __typename?: 'RoutineHeader';
        title: string | null;
        description: string | null;
        asset: {
          __typename?: 'RoutineAsset';
          type: RoutineAssetEnum | null;
          alt: string | null;
          src: string | null;
        } | null;
      } | null;
      items: Array<{
        __typename?: 'RoutineItem';
        description: string | null;
        productId: number;
      } | null> | null;
    } | null;
  };
};

export type GetServicesIncludedQueryVariables = Exact<{
  productsIds: Scalars['String'];
}>;

export type GetServicesIncludedQuery = {
  __typename?: 'Query';
  CartServicesIncluded: {
    __typename?: 'ServicesIncluded';
    engravingShow: boolean;
    tryFirstShow: boolean;
  } | null;
};

export type GetUserEmailClientQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserEmailClientQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    userEmail: string | null;
  } | null;
};

export type CheckEmailSamplingQueryVariables = Exact<{
  email: Scalars['String'];
  campaignId: Scalars['String'];
}>;

export type CheckEmailSamplingQuery = {
  __typename?: 'Query';
  samplingIsValidEmail: { __typename?: 'ValidEmail'; isValidEmail: boolean };
};

export type CreateSamplingOrderMutationVariables = Exact<{
  campaignId: Scalars['Int'];
  customer: CustomerInput;
}>;

export type CreateSamplingOrderMutation = {
  __typename?: 'Mutation';
  samplingCreateOrder: {
    __typename?: 'SamplingOrderResponse';
    id: string | null;
    campaignId: string | null;
    customer: {
      __typename?: 'SamplingCustomer';
      name: string | null;
      email: string | null;
      address: string | null;
      city: string | null;
      zip: string | null;
    } | null;
  };
};

export type CheckEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type CheckEmailQuery = {
  __typename?: 'Query';
  isValidEmail: { __typename?: 'ValidEmail'; isValidEmail: boolean };
};

export type FreetextQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type FreetextQuery = {
  __typename?: 'Query';
  freetext: {
    __typename?: 'Freetext';
    title: string;
    type: string;
    content: string;
  } | null;
};

export type GetTnbProducsQueryVariables = Exact<{
  tokenId?: InputMaybe<Scalars['String']>;
}>;

export type GetTnbProducsQuery = {
  __typename?: 'Query';
  tnbProducts: Array<{
    __typename?: 'TnBProduct';
    code: string | null;
    brand: string | null;
    name: string | null;
    type: string | null;
    gender: string;
    group: Array<string | null> | null;
    url: string | null;
    img: string | null;
    accord: string | null;
  } | null>;
  tnbToken: {
    __typename?: 'TnBToken';
    id: string | null;
    orderId: string | null;
    status: string | null;
    product: {
      __typename?: 'TnBTokenProduct';
      orderCode: string | null;
    } | null;
  };
  tnbSettings: {
    __typename?: 'tnbSettings';
    defaultGender: string;
    defaultGroup: string;
    phoneRegex: string;
    zipRegex: string;
  };
};

export type TnbProductRecomQueryVariables = Exact<{
  samples: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;

export type TnbProductRecomQuery = {
  __typename?: 'Query';
  tnbProductRecom: Array<string | null>;
};

export type SendOrderMutationVariables = Exact<{
  order?: InputMaybe<TnbOrderInput>;
}>;

export type SendOrderMutation = {
  __typename?: 'Mutation';
  tnbCreateOrder: {
    __typename?: 'tnbOrderResponse';
    success: boolean;
    orderNumber: string | null;
  };
};

export type GetTnbProducsListQueryVariables = Exact<{ [key: string]: never }>;

export type GetTnbProducsListQuery = {
  __typename?: 'Query';
  tnbProducts: Array<{
    __typename?: 'TnBProduct';
    code: string | null;
    brand: string | null;
    name: string | null;
    type: string | null;
    gender: string;
    group: Array<string | null> | null;
    url: string | null;
    img: string | null;
    accord: string | null;
  } | null>;
};

export type GetUserEmailQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserEmailQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    info: { __typename?: 'UserInfo'; email: string | null } | null;
  } | null;
};

export type GetTnbCampaignItemsQueryVariables = Exact<{
  campaignId: Scalars['Int'];
}>;

export type GetTnbCampaignItemsQuery = {
  __typename?: 'Query';
  tnbCampaign: {
    __typename?: 'TnbCampaign';
    pickerItemComponentType: number | null;
    items: Array<{
      __typename?: 'TnbItem';
      productId: number | null;
      displayOrder: number | null;
      orderCode: string | null;
      useCustomImage: boolean | null;
      customImageUrl: string | null;
      useCustomText: boolean | null;
      customDisplayText: string | null;
      brandName: string | null;
      name: string | null;
      variantName: string | null;
      additionalInfo: string | null;
      additionalText: string | null;
      images: Array<{
        __typename?: 'TnbItemImage';
        alt: string | null;
        src: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetTnbCampaignQueryVariables = Exact<{
  campaignId: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
}>;

export type GetTnbCampaignQuery = {
  __typename?: 'Query';
  tnbCampaign: {
    __typename?: 'TnbCampaign';
    id: number | null;
    name: string | null;
    isActive: boolean | null;
    isTresholdReached: boolean | null;
    sampleCount: number | null;
    thankYouImage: string | null;
    minOrderCount: number | null;
    enableMultiOpenPicker: boolean | null;
    closeAfterItemSelect: boolean | null;
    pickerItemComponentType: number | null;
    isFirstPickerOpened: boolean | null;
    isMarketingConsentRequired: boolean | null;
    sendConfirmationEmail: boolean | null;
    displayMarketingConsent: boolean | null;
    isSmsValidationOn: boolean | null;
    shopId: string | null;
    items: Array<{
      __typename?: 'TnbItem';
      productId: number | null;
      displayOrder: number | null;
      orderCode: string | null;
      useCustomImage: boolean | null;
      customImageUrl: string | null;
      useCustomText: boolean | null;
      customDisplayText: string | null;
      brandName: string | null;
      name: string | null;
      variantName: string | null;
      additionalInfo: string | null;
      additionalText: string | null;
      images: Array<{
        __typename?: 'TnbItemImage';
        alt: string | null;
        src: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};

export type TnbMakeOrderMutationVariables = Exact<{
  order: TnbMakeOrderInput;
}>;

export type TnbMakeOrderMutation = {
  __typename?: 'Mutation';
  tnbMakeOrder: {
    __typename?: 'TnbMakeOrderResponse';
    success: boolean | null;
    error: string | null;
    emailIsUsed: boolean | null;
    phoneIsUsed: boolean | null;
  } | null;
};

export type TnbSmsValidationMutationVariables = Exact<{
  validationData: TnbSmsValidationInput;
}>;

export type TnbSmsValidationMutation = {
  __typename?: 'Mutation';
  tnbSmsValidation: string | null;
};

export type CopyWishlistMutationVariables = Exact<{
  owner?: InputMaybe<Scalars['String']>;
  anonymousId?: InputMaybe<Scalars['String']>;
}>;

export type CopyWishlistMutation = {
  __typename?: 'Mutation';
  WishlistCopyWishlist: { __typename?: 'WishlistId'; id: string } | null;
};

export type GetWishlistByLoggedUserOrOwnerQueryVariables = Exact<{
  owner?: InputMaybe<Scalars['String']>;
}>;

export type GetWishlistByLoggedUserOrOwnerQuery = {
  __typename?: 'Query';
  WishlistByLoggedUserOrOwner: {
    __typename?: 'Wishlist';
    products: Array<string | null>;
    id: string;
  } | null;
  user: { __typename?: 'User'; id: string | null } | null;
};

export type AppFeatureSwitchesFragment = {
  __typename?: 'FeatureSwitches';
  modifaceMobileEnabled: string | null;
  modifaceDesktopEnabled: string | null;
  reviewsOnServerIds: string | null;
  addToCartResendDelay: string | null;
  addToCartWarningCount: string | null;
};

export type ProductDetailViewFragmentFragment = {
  __typename?: 'Product';
  id: string;
  brand: string | null;
  brandId: number | null;
  url: string;
  collection: string | null;
  annotation: string | null;
  subName: string | null;
  code: string | null;
  kind: string | null;
  category: Array<string | null> | null;
  subCategory: Array<string | null> | null;
  type: Array<string | null> | null;
  marketType: string | null;
  manufacturer: string | null;
  description: string | null;
  unit: string | null;
  orderUnit: string | null;
  hasDifferentColors: boolean | null;
  isPerfume: boolean | null;
  isForbiddenToDisplay: boolean | null;
  variantDisplayType: VariantDisplayType | null;
  isShadeFinderAvailable: boolean | null;
  brandInfo: {
    __typename?: 'Brand';
    id: string;
    name: string;
    description: string | null;
    url: string | null;
  } | null;
  breadcrumb: Array<{
    __typename?: 'Breadcrumb';
    name: string;
    link: string | null;
  } | null> | null;
  config: {
    __typename?: 'ProductConfig';
    showAddToCartButton: boolean | null;
    showAddToCartModal: boolean | null;
  };
  variants: Array<{
    __typename?: 'Variant';
    id: string | null;
    name: string | null;
    annotation: string | null;
    orderCode: string | null;
    productCode: string | null;
    eanCode: string | null;
    gender: string | null;
    attributes: any | null;
    navigationValues: Array<number | null> | null;
    descriptionOverride: string | null;
    modifaceMakeUpData: Array<any | null> | null;
    canBuy: boolean | null;
    nextDeliveryDate: string | null;
    availablePickUpStores: number | null;
    url: string | null;
    videos: Array<string | null> | null;
    maxOrderQty: number | null;
    showWatchdog: boolean | null;
    additionalInfo: string | null;
    additionalText: string | null;
    variantName: string | null;
    color: string | null;
    colors: Array<string | null> | null;
    wishlisted: boolean | null;
    engraving: {
      __typename?: 'Engraving';
      allowed: boolean | null;
      characterCount: number | null;
      image: string | null;
      config: {
        __typename?: 'EngravingConfig';
        isAvailable: boolean | null;
        price: number | null;
      } | null;
    } | null;
    hairModifaceEffects: Array<{
      __typename?: 'HairModifaceEffects';
      upc: string | null;
      category: string | null;
      shades: Array<{
        __typename?: 'ModifaceHairShade';
        histogram_r: string | null;
        histogram_g: string | null;
        histogram_b: string | null;
        histogram_c: string | null;
        totalpixels: number | null;
        intensity: number | null;
        shine: number | null;
        effect: number | null;
        blendGradientTopOffset: number | null;
        blendGradientBottomOffset: number | null;
        enableRootRecoloring: boolean | null;
        renderingVersion: number | null;
        family: string | null;
        shazamColorFamily: string | null;
      } | null> | null;
    } | null> | null;
    seo: {
      __typename?: 'Seo';
      title: string | null;
      description: string | null;
      keywords: string | null;
    } | null;
    parameters: {
      __typename?: 'Parameters';
      amount: number | null;
      package: string | null;
    } | null;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    unitPrice: {
      __typename?: 'UnitPriceDetail';
      value: number | null;
      currency: string | null;
      tax: number | null;
      unit: string | null;
      perAmount: number | null;
    } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    imagesByCategory: {
      __typename?: 'ImagesByCategory';
      mainImage: {
        __typename?: 'Image';
        alt: string | null;
        src: string | null;
      };
      previewImage: {
        __typename?: 'Image';
        alt: string | null;
        src: string | null;
      } | null;
      shadeImage: {
        __typename?: 'Image';
        alt: string | null;
        src: string | null;
      } | null;
      others: Array<{
        __typename?: 'Image';
        alt: string | null;
        src: string | null;
      } | null> | null;
    } | null;
    originalPrice: {
      __typename?: 'OriginalPrice';
      value: number | null;
      currency: string | null;
      tax: number | null;
      type: string | null;
    } | null;
    recentMinPrice: {
      __typename?: 'RecentMinPrice';
      value: number | null;
      currency: string | null;
      tax: number | null;
      isActionEligible: boolean | null;
    } | null;
    campaignConfig: {
      __typename?: 'CampaignConfig';
      allowed: EGiftPackagingAllowedType | null;
      price: number | null;
      groupName: string | null;
    } | null;
    characteristics: Array<{
      __typename?: 'Characteristic';
      name: string | null;
      help: string | null;
      values: Array<string | null> | null;
    } | null> | null;
    legalInformation: {
      __typename?: 'LegalInformation';
      document: string | null;
      video: string | null;
      instructions: string | null;
      ingredients: string | null;
      foodComposition: string | null;
      nutritionValues: string | null;
      isSensitiveHairProduct: boolean | null;
      preparationUsage: string | null;
      specialStorage: string | null;
      manufacturerImporter: string | null;
      importantNotice: string | null;
      instructionDocument: {
        __typename?: 'InstructionDocument';
        url: string;
        type: InstructionDocumentType;
      } | null;
      compositionTables: {
        __typename?: 'CompositionTables';
        vitaminsAndMinerals: Array<{
          __typename?: 'VitaminsAndMinerals';
          nutritionValue: string | null;
          amountSign: string | null;
          amount: number | null;
          measureUnit: string | null;
          onePortionAmount: number | null;
          referenceValue: number | null;
          referenceValueOnePercent: number | null;
          referenceValuePercent: number | null;
        }> | null;
        nutritionValues: Array<{
          __typename?: 'NutritionValue';
          nutritionValue: string | null;
          amountSign: string | null;
          amount: number | null;
          measureUnit: string | null;
          variantAmount: number | null;
        }> | null;
      } | null;
    } | null;
    customerBenefits: {
      __typename?: 'VariantCustomerBenefits';
      availableDiscount: {
        __typename?: 'Discount';
        value: number | null;
        discountSubject: string | null;
        subjectType: SubjectType | null;
        discountType: DiscountType | null;
      } | null;
      customerDiscount: {
        __typename?: 'Discount';
        value: number | null;
        discountSubject: string | null;
        subjectType: SubjectType | null;
        discountType: DiscountType | null;
      } | null;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      subCategory: string;
      kind: string;
      type: string;
    };
  } | null> | null;
  alternateSites: Array<{
    __typename?: 'AlternateSite';
    link: string | null;
    culture: string | null;
  } | null> | null;
  campaigns: Array<{
    __typename?: 'Campaign';
    campaignId: string | null;
    name: string | null;
    imageUrl: string | null;
    text: string | null;
    detailPageText: string | null;
    displayOnDetailPage: boolean | null;
    giftImageUrl: string | null;
    giftType: GiftType | null;
    productId: string | null;
  } | null> | null;
  related: Array<{ __typename?: 'Product'; id: string } | null> | null;
  deliveries: Array<{
    __typename?: 'Delivery';
    name: string | null;
    date: string | null;
    isPersonal: boolean | null;
    isAirTransport: boolean | null;
    disallowedReason: string | null;
    dateFrom: string | null;
    dateTo: string | null;
  } | null> | null;
  composition: Array<{
    __typename?: 'Characteristic';
    name: string | null;
    help: string | null;
    link: string | null;
    values: Array<string | null> | null;
  } | null> | null;
  relatedArticles: Array<{
    __typename?: 'Article';
    title: string | null;
    url: string | null;
    description: string | null;
    image: string | null;
    date: string | null;
    author: string | null;
  } | null> | null;
  primaryCategories: {
    __typename?: 'PrimaryCategories';
    category: string;
    subCategory: string;
    kind: string;
    type: string;
  };
  categorization: {
    __typename?: 'Categorization';
    kinds: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
    categories: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
    types: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
    subCategories: Array<{
      __typename?: 'CategorizationItem';
      id: number;
    }> | null;
  };
};

export type VariantFragmentFragment = {
  __typename?: 'Variant';
  id: string | null;
  name: string | null;
  annotation: string | null;
  orderCode: string | null;
  productCode: string | null;
  eanCode: string | null;
  gender: string | null;
  attributes: any | null;
  navigationValues: Array<number | null> | null;
  descriptionOverride: string | null;
  modifaceMakeUpData: Array<any | null> | null;
  canBuy: boolean | null;
  nextDeliveryDate: string | null;
  availablePickUpStores: number | null;
  url: string | null;
  videos: Array<string | null> | null;
  maxOrderQty: number | null;
  showWatchdog: boolean | null;
  additionalInfo: string | null;
  additionalText: string | null;
  variantName: string | null;
  color: string | null;
  colors: Array<string | null> | null;
  wishlisted: boolean | null;
  engraving: {
    __typename?: 'Engraving';
    allowed: boolean | null;
    characterCount: number | null;
    image: string | null;
    config: {
      __typename?: 'EngravingConfig';
      isAvailable: boolean | null;
      price: number | null;
    } | null;
  } | null;
  hairModifaceEffects: Array<{
    __typename?: 'HairModifaceEffects';
    upc: string | null;
    category: string | null;
    shades: Array<{
      __typename?: 'ModifaceHairShade';
      histogram_r: string | null;
      histogram_g: string | null;
      histogram_b: string | null;
      histogram_c: string | null;
      totalpixels: number | null;
      intensity: number | null;
      shine: number | null;
      effect: number | null;
      blendGradientTopOffset: number | null;
      blendGradientBottomOffset: number | null;
      enableRootRecoloring: boolean | null;
      renderingVersion: number | null;
      family: string | null;
      shazamColorFamily: string | null;
    } | null> | null;
  } | null> | null;
  seo: {
    __typename?: 'Seo';
    title: string | null;
    description: string | null;
    keywords: string | null;
  } | null;
  parameters: {
    __typename?: 'Parameters';
    amount: number | null;
    package: string | null;
  } | null;
  price: {
    __typename?: 'Price';
    value: number | null;
    currency: string | null;
    tax: number | null;
  } | null;
  unitPrice: {
    __typename?: 'UnitPriceDetail';
    value: number | null;
    currency: string | null;
    tax: number | null;
    unit: string | null;
    perAmount: number | null;
  } | null;
  stockAvailability: {
    __typename?: 'StockInfo';
    code: string | null;
    count: number | null;
  } | null;
  imagesByCategory: {
    __typename?: 'ImagesByCategory';
    mainImage: { __typename?: 'Image'; alt: string | null; src: string | null };
    previewImage: {
      __typename?: 'Image';
      alt: string | null;
      src: string | null;
    } | null;
    shadeImage: {
      __typename?: 'Image';
      alt: string | null;
      src: string | null;
    } | null;
    others: Array<{
      __typename?: 'Image';
      alt: string | null;
      src: string | null;
    } | null> | null;
  } | null;
  originalPrice: {
    __typename?: 'OriginalPrice';
    value: number | null;
    currency: string | null;
    tax: number | null;
    type: string | null;
  } | null;
  recentMinPrice: {
    __typename?: 'RecentMinPrice';
    value: number | null;
    currency: string | null;
    tax: number | null;
    isActionEligible: boolean | null;
  } | null;
  campaignConfig: {
    __typename?: 'CampaignConfig';
    allowed: EGiftPackagingAllowedType | null;
    price: number | null;
    groupName: string | null;
  } | null;
  characteristics: Array<{
    __typename?: 'Characteristic';
    name: string | null;
    help: string | null;
    values: Array<string | null> | null;
  } | null> | null;
  legalInformation: {
    __typename?: 'LegalInformation';
    document: string | null;
    video: string | null;
    instructions: string | null;
    ingredients: string | null;
    foodComposition: string | null;
    nutritionValues: string | null;
    isSensitiveHairProduct: boolean | null;
    preparationUsage: string | null;
    specialStorage: string | null;
    manufacturerImporter: string | null;
    importantNotice: string | null;
    instructionDocument: {
      __typename?: 'InstructionDocument';
      url: string;
      type: InstructionDocumentType;
    } | null;
    compositionTables: {
      __typename?: 'CompositionTables';
      vitaminsAndMinerals: Array<{
        __typename?: 'VitaminsAndMinerals';
        nutritionValue: string | null;
        amountSign: string | null;
        amount: number | null;
        measureUnit: string | null;
        onePortionAmount: number | null;
        referenceValue: number | null;
        referenceValueOnePercent: number | null;
        referenceValuePercent: number | null;
      }> | null;
      nutritionValues: Array<{
        __typename?: 'NutritionValue';
        nutritionValue: string | null;
        amountSign: string | null;
        amount: number | null;
        measureUnit: string | null;
        variantAmount: number | null;
      }> | null;
    } | null;
  } | null;
  customerBenefits: {
    __typename?: 'VariantCustomerBenefits';
    availableDiscount: {
      __typename?: 'Discount';
      value: number | null;
      discountSubject: string | null;
      subjectType: SubjectType | null;
      discountType: DiscountType | null;
    } | null;
    customerDiscount: {
      __typename?: 'Discount';
      value: number | null;
      discountSubject: string | null;
      subjectType: SubjectType | null;
      discountType: DiscountType | null;
    } | null;
  } | null;
  primaryCategories: {
    __typename?: 'PrimaryCategories';
    category: string;
    subCategory: string;
    kind: string;
    type: string;
  };
};

export type GetCurrencyQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrencyQuery = {
  __typename?: 'Query';
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
  };
};

export type GetDefaultDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultDataQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    role: string;
    userId: string;
    userEmail: string | null;
    userName: string | null;
    abTest: string | null;
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    assetsPath: string;
    sentryDsn: string;
    sentryEnvironment: string;
    sentryTracingRate: number;
    originUrl: string | null;
    mounts: Array<string>;
    features: string;
  } | null;
  ProductSsrData: {
    __typename: 'ClientProductSsr';
    id: string | null;
    pathname: string | null;
    productId: string | null;
    type: string | null;
  } | null;
};

export type GetMasterProductInfoQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type GetMasterProductInfoQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    id: string;
    manufacturer: string | null;
    annotation: string | null;
    collection: string | null;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    brandInfo: {
      __typename?: 'Brand';
      id: string;
      name: string;
      description: string | null;
      url: string | null;
    } | null;
  } | null> | null;
};

export type GetProductViewQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type GetProductViewQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    id: string;
    brand: string | null;
    brandId: number | null;
    url: string;
    collection: string | null;
    annotation: string | null;
    subName: string | null;
    code: string | null;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    marketType: string | null;
    manufacturer: string | null;
    description: string | null;
    unit: string | null;
    orderUnit: string | null;
    hasDifferentColors: boolean | null;
    isPerfume: boolean | null;
    isForbiddenToDisplay: boolean | null;
    variantDisplayType: VariantDisplayType | null;
    isShadeFinderAvailable: boolean | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      count: number;
      rating: number;
      textReviewsCount: number;
      translatedReviewsCount: number;
    } | null;
    brandInfo: {
      __typename?: 'Brand';
      id: string;
      name: string;
      description: string | null;
      url: string | null;
    } | null;
    breadcrumb: Array<{
      __typename?: 'Breadcrumb';
      name: string;
      link: string | null;
    } | null> | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartButton: boolean | null;
      showAddToCartModal: boolean | null;
    };
    variants: Array<{
      __typename?: 'Variant';
      id: string | null;
      name: string | null;
      annotation: string | null;
      orderCode: string | null;
      productCode: string | null;
      eanCode: string | null;
      gender: string | null;
      attributes: any | null;
      navigationValues: Array<number | null> | null;
      descriptionOverride: string | null;
      modifaceMakeUpData: Array<any | null> | null;
      canBuy: boolean | null;
      nextDeliveryDate: string | null;
      availablePickUpStores: number | null;
      url: string | null;
      videos: Array<string | null> | null;
      maxOrderQty: number | null;
      showWatchdog: boolean | null;
      additionalInfo: string | null;
      additionalText: string | null;
      variantName: string | null;
      color: string | null;
      colors: Array<string | null> | null;
      wishlisted: boolean | null;
      engraving: {
        __typename?: 'Engraving';
        allowed: boolean | null;
        characterCount: number | null;
        image: string | null;
        config: {
          __typename?: 'EngravingConfig';
          isAvailable: boolean | null;
          price: number | null;
        } | null;
      } | null;
      hairModifaceEffects: Array<{
        __typename?: 'HairModifaceEffects';
        upc: string | null;
        category: string | null;
        shades: Array<{
          __typename?: 'ModifaceHairShade';
          histogram_r: string | null;
          histogram_g: string | null;
          histogram_b: string | null;
          histogram_c: string | null;
          totalpixels: number | null;
          intensity: number | null;
          shine: number | null;
          effect: number | null;
          blendGradientTopOffset: number | null;
          blendGradientBottomOffset: number | null;
          enableRootRecoloring: boolean | null;
          renderingVersion: number | null;
          family: string | null;
          shazamColorFamily: string | null;
        } | null> | null;
      } | null> | null;
      seo: {
        __typename?: 'Seo';
        title: string | null;
        description: string | null;
        keywords: string | null;
      } | null;
      parameters: {
        __typename?: 'Parameters';
        amount: number | null;
        package: string | null;
      } | null;
      price: {
        __typename?: 'Price';
        value: number | null;
        currency: string | null;
        tax: number | null;
      } | null;
      unitPrice: {
        __typename?: 'UnitPriceDetail';
        value: number | null;
        currency: string | null;
        tax: number | null;
        unit: string | null;
        perAmount: number | null;
      } | null;
      stockAvailability: {
        __typename?: 'StockInfo';
        code: string | null;
        count: number | null;
      } | null;
      imagesByCategory: {
        __typename?: 'ImagesByCategory';
        mainImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        };
        previewImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        } | null;
        shadeImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        } | null;
        others: Array<{
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        } | null> | null;
      } | null;
      originalPrice: {
        __typename?: 'OriginalPrice';
        value: number | null;
        currency: string | null;
        tax: number | null;
        type: string | null;
      } | null;
      recentMinPrice: {
        __typename?: 'RecentMinPrice';
        value: number | null;
        currency: string | null;
        tax: number | null;
        isActionEligible: boolean | null;
      } | null;
      campaignConfig: {
        __typename?: 'CampaignConfig';
        allowed: EGiftPackagingAllowedType | null;
        price: number | null;
        groupName: string | null;
      } | null;
      characteristics: Array<{
        __typename?: 'Characteristic';
        name: string | null;
        help: string | null;
        values: Array<string | null> | null;
      } | null> | null;
      legalInformation: {
        __typename?: 'LegalInformation';
        document: string | null;
        video: string | null;
        instructions: string | null;
        ingredients: string | null;
        foodComposition: string | null;
        nutritionValues: string | null;
        isSensitiveHairProduct: boolean | null;
        preparationUsage: string | null;
        specialStorage: string | null;
        manufacturerImporter: string | null;
        importantNotice: string | null;
        instructionDocument: {
          __typename?: 'InstructionDocument';
          url: string;
          type: InstructionDocumentType;
        } | null;
        compositionTables: {
          __typename?: 'CompositionTables';
          vitaminsAndMinerals: Array<{
            __typename?: 'VitaminsAndMinerals';
            nutritionValue: string | null;
            amountSign: string | null;
            amount: number | null;
            measureUnit: string | null;
            onePortionAmount: number | null;
            referenceValue: number | null;
            referenceValueOnePercent: number | null;
            referenceValuePercent: number | null;
          }> | null;
          nutritionValues: Array<{
            __typename?: 'NutritionValue';
            nutritionValue: string | null;
            amountSign: string | null;
            amount: number | null;
            measureUnit: string | null;
            variantAmount: number | null;
          }> | null;
        } | null;
      } | null;
      customerBenefits: {
        __typename?: 'VariantCustomerBenefits';
        availableDiscount: {
          __typename?: 'Discount';
          value: number | null;
          discountSubject: string | null;
          subjectType: SubjectType | null;
          discountType: DiscountType | null;
        } | null;
        customerDiscount: {
          __typename?: 'Discount';
          value: number | null;
          discountSubject: string | null;
          subjectType: SubjectType | null;
          discountType: DiscountType | null;
        } | null;
      } | null;
      primaryCategories: {
        __typename?: 'PrimaryCategories';
        category: string;
        subCategory: string;
        kind: string;
        type: string;
      };
    } | null> | null;
    alternateSites: Array<{
      __typename?: 'AlternateSite';
      link: string | null;
      culture: string | null;
    } | null> | null;
    campaigns: Array<{
      __typename?: 'Campaign';
      campaignId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
    } | null> | null;
    related: Array<{ __typename?: 'Product'; id: string } | null> | null;
    deliveries: Array<{
      __typename?: 'Delivery';
      name: string | null;
      date: string | null;
      isPersonal: boolean | null;
      isAirTransport: boolean | null;
      disallowedReason: string | null;
      dateFrom: string | null;
      dateTo: string | null;
    } | null> | null;
    composition: Array<{
      __typename?: 'Characteristic';
      name: string | null;
      help: string | null;
      link: string | null;
      values: Array<string | null> | null;
    } | null> | null;
    relatedArticles: Array<{
      __typename?: 'Article';
      title: string | null;
      url: string | null;
      description: string | null;
      image: string | null;
      date: string | null;
      author: string | null;
    } | null> | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      category: string;
      subCategory: string;
      kind: string;
      type: string;
    };
    categorization: {
      __typename?: 'Categorization';
      kinds: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
      categories: Array<{
        __typename?: 'CategorizationItem';
        id: number;
      }> | null;
      types: Array<{ __typename?: 'CategorizationItem'; id: number }> | null;
      subCategories: Array<{
        __typename?: 'CategorizationItem';
        id: number;
      }> | null;
    };
  } | null> | null;
  Settings: {
    __typename?: 'Settings';
    imageDomainPath: string;
    deliveriesDisplayMode: string | null;
    showUnitPrices: boolean | null;
    isWishlistAllowed: boolean | null;
    isNewShoppingCartEndpointEnabled: boolean | null;
    featureSwitches: {
      __typename?: 'FeatureSwitches';
      modifaceMobileEnabled: string | null;
      modifaceDesktopEnabled: string | null;
      reviewsOnServerIds: string | null;
      addToCartResendDelay: string | null;
      addToCartWarningCount: string | null;
    } | null;
  };
  shopSettings: { __typename?: 'Shop'; countryCode: string } | null;
  userProductsInfo: Array<{
    __typename?: 'UserProductInfo';
    productId: string | null;
    isComparison: boolean | null;
  } | null> | null;
  currentLocale: {
    __typename?: 'Locale';
    id: number | null;
    tag: string | null;
    currency: string | null;
    priceDecimalPlaces: number | null;
    priceFormat: string | null;
  };
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
  user: {
    __typename?: 'User';
    id: string | null;
    role: Roles | null;
    cartId: string | null;
    comparisonIds: string | null;
    consent: Array<string>;
  } | null;
};

export type GetRequestHeadersQueryVariables = Exact<{ [key: string]: never }>;

export type GetRequestHeadersQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    userId: string;
    userName: string | null;
    userEmail: string | null;
    assetsPath: string;
    abTest: string | null;
    sentryDsn: string;
    sentryEnvironment: string;
    sentryTracingRate: number;
    originUrl: string | null;
    mounts: Array<string>;
    role: string;
    features: string;
    hrkDefaultCurrency: {
      __typename?: 'HrkDefaultCurrency';
      code: string;
      exchangeRates: {
        __typename?: 'HrkExchangeRates';
        EUR: number | null;
        HRK: number | null;
      } | null;
    };
    ldFlags: {
      __typename: 'LdFeatures';
      chatbot: boolean | null;
      gatewayRouterProxyEnabled: boolean | null;
      spaRedirectWishlistToPd: boolean | null;
      strictSalesDisplay: boolean | null;
      dualCurrencyPrice: boolean | null;
      conditionalVoucherDiscount: boolean | null;
      modifaceIntensitySlider: boolean | null;
      loyaltyGa4: boolean | null;
      shadeFinderTryItFirstProductMasterIds: Array<string> | null;
      newPdDesign: boolean | null;
      virtualTryOnState: string | null;
      voucherNewDesign: boolean | null;
      pdSetImmediateEnabled: boolean | null;
      shadefinderEnabled: boolean | null;
      klarnaNushopId: string | null;
      bazaarvoiceCookieConsentMapping: boolean | null;
      wishlistSsrEnabled: boolean | null;
      swogoIntegrationEnabled: boolean | null;
      recoProductDetailAddToCart: boolean | null;
      recoProductDetail: boolean | null;
      newNutritionAndVitaminsTable: boolean | null;
      hasJsonLdOfferVoucherPrice: boolean | null;
      swogoIgnoreConvertedPrice: boolean | null;
      pdHasAllReviewsPage: boolean | null;
      newBlogEndpoint: boolean | null;
      newDermoIcon: boolean | null;
      livestreamOnPdEnabled: boolean | null;
      pictogramsEnabled: boolean | null;
      bazaarvoiceIntegrationPd: {
        __typename?: 'BazaarvoiceIntegrationType';
        siteId: string;
        locale: string;
        environment: string;
      } | null;
    };
  } | null;
};

export type GetShowUnitPricesQueryVariables = Exact<{ [key: string]: never }>;

export type GetShowUnitPricesQuery = {
  __typename?: 'Query';
  Settings: { __typename?: 'Settings'; showUnitPrices: boolean | null };
};

export type LoggedInUserReviewQueryVariables = Exact<{
  masterProductCode: Scalars['String'];
}>;

export type LoggedInUserReviewQuery = {
  __typename?: 'Query';
  loggedInUserReview: {
    __typename?: 'LoggedInUserReview';
    id: number;
    name: string;
    text: string | null;
    digests: Array<string> | null;
    score: number;
    source: string | null;
    ratings: Array<{
      __typename?: 'ReviewRating';
      id: number;
      ratingType: string;
      score: number;
    }> | null;
  } | null;
};

export type GetReviewSummaryQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type GetReviewSummaryQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    id: string;
    reviewSummary: {
      __typename?: 'ReviewSummary';
      averageRating: number;
      totalVotes: number;
      votes: any | null;
      ratings: Array<{
        __typename?: 'ReviewRating';
        id: number;
        score: number;
        ratingType: string;
      }>;
    } | null;
    reviewOverview: {
      __typename?: 'ReviewOverview';
      textReviewsCount: number;
    } | null;
  } | null> | null;
};

export type GetReviewsQueryVariables = Exact<{
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  orderDesc: Scalars['Boolean'];
  orderBy: ReviewOrderBy;
  code: Scalars['String'];
  hideTranslated?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetReviewsQuery = {
  __typename?: 'Query';
  reviews: Array<{
    __typename?: 'Review';
    id: number;
    text: string | null;
    userName: string;
    score: number;
    createdDate: string;
    like: number;
    dislike: number;
    alreadyLiked: boolean;
    alreadyDisliked: boolean;
    translatedFrom: string | null;
    authorType: AuthorType;
    originalShopId: string | null;
  }>;
};

export type GetFullUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetFullUserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string | null;
    cartId: string | null;
    comparisonIds: string | null;
    role: Roles | null;
    consent: Array<string>;
  } | null;
};

export type GetGdprPathsQueryVariables = Exact<{ [key: string]: never }>;

export type GetGdprPathsQuery = {
  __typename?: 'Query';
  shopSettings: {
    __typename?: 'Shop';
    gdprSettings: {
      __typename?: 'GdprSettings';
      termsAndConditionsUrl: string | null;
      securityAndPrivacyUrl: string | null;
    };
  } | null;
};

export type FragmentUpsellingProductFragment = {
  __typename?: 'VpProduct';
  id: string | null;
  url: string | null;
  imageUrl: string | null;
  name: string | null;
  annotation: string | null;
  productCode: string | null;
  wishlisted: boolean | null;
  attributes: any | null;
  showWatchdog: boolean;
  canBuy: boolean;
  masterId: number | null;
  price: {
    __typename?: 'Price';
    value: number | null;
    currency: string | null;
    tax: number | null;
  } | null;
  config: {
    __typename?: 'ProductConfig';
    showAddToCartModal: boolean | null;
    showAddToCartButton: boolean | null;
  };
  brand: { __typename?: 'Brand'; name: string } | null;
  stockAvailability: {
    __typename?: 'StockInfo';
    code: string | null;
    count: number | null;
  } | null;
  primaryCategories: {
    __typename?: 'PrimaryCategories';
    type: string;
    kind: string;
    subCategory: string;
    category: string;
  };
};

export type GetUpsellingDataQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetUpsellingDataQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    annotation: string | null;
    productCode: string | null;
    wishlisted: boolean | null;
    attributes: any | null;
    showWatchdog: boolean;
    canBuy: boolean;
    masterId: number | null;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    config: {
      __typename?: 'ProductConfig';
      showAddToCartModal: boolean | null;
      showAddToCartButton: boolean | null;
    };
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
    primaryCategories: {
      __typename?: 'PrimaryCategories';
      type: string;
      kind: string;
      subCategory: string;
      category: string;
    };
  } | null>;
};

export type UpsellingProductsQueryVariables = Exact<{
  productCodes: Array<Scalars['String']> | Scalars['String'];
}>;

export type UpsellingProductsQuery = {
  __typename?: 'Query';
  getUpsellingProductsForMultiple: Array<string>;
};

export type GetProductByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetProductByIdsQuery = {
  __typename?: 'Query';
  vpProductByIds: Array<{
    __typename?: 'VpProduct';
    id: string | null;
    url: string | null;
    imageUrl: string | null;
    name: string | null;
    annotation: string | null;
    productCode: string | null;
    orderUnit: string | null;
    price: {
      __typename?: 'Price';
      value: number | null;
      currency: string | null;
      tax: number | null;
    } | null;
    brand: { __typename?: 'Brand'; name: string } | null;
    stockAvailability: {
      __typename?: 'StockInfo';
      code: string | null;
      count: number | null;
    } | null;
  } | null>;
  currentCurrency: {
    __typename?: 'Currency';
    id: number | null;
    code: string | null;
    symbol: string | null;
  };
};

export type AddProductsToCartMutationVariables = Exact<{
  products: Array<ProductToCartInput> | ProductToCartInput;
  services?: InputMaybe<Array<CartServiceInput> | CartServiceInput>;
}>;

export type AddProductsToCartMutation = {
  __typename?: 'Mutation';
  AddProductsToCart: {
    __typename?: 'AddProductsResponse';
    productAddResponse: Array<{
      __typename?: 'CartProducts';
      productId: number;
      itemId: number;
      messages: Array<string>;
      productIncrease: number;
      cart: {
        __typename?: 'CartContent';
        cartId: string;
        products: Array<{
          __typename?: 'CartContentProduct';
          count: number;
          itemId: number;
          productId: number;
        } | null> | null;
      };
    } | null> | null;
    serviceAddResponse: Array<{
      __typename?: 'CartServiceAddResponse';
      status: Array<CartProductStatus | null>;
      service: {
        __typename?: 'CartAddedService';
        type: CartServiceType | null;
      } | null;
    } | null> | null;
  };
};

export type AddToCartSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type AddToCartSettingsQuery = {
  __typename?: 'Query';
  Settings: {
    __typename?: 'Settings';
    isNewShoppingCartEndpointEnabled: boolean | null;
    featureSwitches: {
      __typename?: 'FeatureSwitches';
      addToCartResendDelay: string | null;
      addToCartWarningCount: string | null;
    } | null;
  };
};

export type GetUserQueryVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  userProductsInfo: Array<{
    __typename?: 'UserProductInfo';
    productId: string | null;
    isComparison: boolean | null;
  } | null> | null;
};

export type GetRequestInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetRequestInfoQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename?: 'ClientHeaders';
    xUserToken: string | null;
    gatewayUrl: string;
  } | null;
};

export type SendWatchdogMutationVariables = Exact<{
  productId: Scalars['String'];
  email: Scalars['String'];
}>;

export type SendWatchdogMutation = {
  __typename?: 'Mutation';
  sendWatchdog: {
    __typename?: 'WatchDog';
    success: boolean;
    errors: Array<string> | null;
  };
};

export type WatchdogActiveQueryVariables = Exact<{
  productId: Scalars['String'];
}>;

export type WatchdogActiveQuery = {
  __typename?: 'Query';
  watchdogActive: { __typename?: 'WatchdogActive'; watchdogActive: boolean };
};

export type TestCampaignsQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type TestCampaignsQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename: 'Product';
    campaigns: Array<{
      __typename: 'Campaign';
      campaignId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
    } | null> | null;
  } | null> | null;
};

export type TestProductDetailByMasterIdQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type TestProductDetailByMasterIdQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename: 'Product';
    id: string;
    brand: string | null;
    brandId: number | null;
    url: string;
    collection: string | null;
    annotation: string | null;
    subName: string | null;
    code: string | null;
    kind: string | null;
    category: Array<string | null> | null;
    subCategory: Array<string | null> | null;
    type: Array<string | null> | null;
    marketType: string | null;
    manufacturer: string | null;
    description: string | null;
    unit: string | null;
    orderUnit: string | null;
    hasDifferentColors: boolean | null;
    isPerfume: boolean | null;
    isForbiddenToDisplay: boolean | null;
    variantDisplayType: VariantDisplayType | null;
    brandInfo: {
      __typename: 'Brand';
      id: string;
      name: string;
      description: string | null;
      url: string | null;
    } | null;
    breadcrumb: Array<{
      __typename: 'Breadcrumb';
      name: string;
      link: string | null;
    } | null> | null;
    seo: {
      __typename: 'Seo';
      title: string | null;
      keywords: string | null;
      description: string | null;
    } | null;
    campaigns: Array<{
      __typename: 'Campaign';
      id: string | null;
      campaignId: string | null;
      name: string | null;
      imageUrl: string | null;
      text: string | null;
      detailPageText: string | null;
      displayOnDetailPage: boolean | null;
      giftImageUrl: string | null;
      giftType: GiftType | null;
      productId: string | null;
    } | null> | null;
    rating: {
      __typename: 'ProductRating';
      score: number | null;
      votes: number | null;
    } | null;
    alternateSites: Array<{
      __typename: 'AlternateSite';
      link: string | null;
      culture: string | null;
    } | null> | null;
    related: Array<{ __typename: 'Product'; id: string } | null> | null;
    deliveries: Array<{
      __typename: 'Delivery';
      name: string | null;
      date: string | null;
      isPersonal: boolean | null;
      isAirTransport: boolean | null;
      disallowedReason: string | null;
    } | null> | null;
    composition: Array<{
      __typename: 'Characteristic';
      name: string | null;
      help: string | null;
      link: string | null;
      values: Array<string | null> | null;
    } | null> | null;
    relatedArticles: Array<{
      __typename: 'Article';
      title: string | null;
      url: string | null;
      description: string | null;
      image: string | null;
      date: string | null;
      author: string | null;
    } | null> | null;
    reviewOverview: {
      __typename: 'ReviewOverview';
      count: number;
      textReviewsCount: number;
      translatedReviewsCount: number;
      rating: number;
    } | null;
    variants: Array<{
      __typename?: 'Variant';
      id: string | null;
      engraving: { __typename?: 'Engraving'; allowed: boolean | null } | null;
    } | null> | null;
  } | null> | null;
};

export type TestSendWatchDogMutationVariables = Exact<{
  productId: Scalars['String'];
  email: Scalars['String'];
}>;

export type TestSendWatchDogMutation = {
  __typename?: 'Mutation';
  sendWatchdog: {
    __typename?: 'WatchDog';
    success: boolean;
    errors: Array<string> | null;
  };
};

export type GetDefaultQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultQueryQuery = {
  __typename?: 'Query';
  RequestHeaders: {
    __typename: 'ClientHeaders';
    groupId: string;
    role: string;
    userId: string;
    userEmail: string | null;
    userName: string | null;
    abTest: string | null;
    shopId: string;
    xUserToken: string | null;
    xLangTag: string | null;
    gatewayUrl: string;
    assetsPath: string;
    sentryDsn: string;
    sentryEnvironment: string;
    modifaceDomain: string | null;
    shadefinderAppId: string | null;
    sentryTracingRate: number;
    originUrl: string | null;
    mounts: Array<string>;
    features: string;
    lastVisitedProducts: Array<string> | null;
    hrkDefaultCurrency: {
      __typename?: 'HrkDefaultCurrency';
      code: string;
      exchangeRates: {
        __typename?: 'HrkExchangeRates';
        EUR: number | null;
        HRK: number | null;
      } | null;
    };
    ldFlags: {
      __typename: 'LdFeatures';
      chatbot: boolean | null;
      gatewayRouterProxyEnabled: boolean | null;
      spaRedirectWishlistToPd: boolean | null;
      strictSalesDisplay: boolean | null;
      dualCurrencyPrice: boolean | null;
      conditionalVoucherDiscount: boolean | null;
      modifaceIntensitySlider: boolean | null;
      loyaltyGa4: boolean | null;
      shadeFinderTryItFirstProductMasterIds: Array<string> | null;
      newPdDesign: boolean | null;
      pdSetImmediateEnabled: boolean | null;
      shadefinderEnabled: boolean | null;
      klarnaNushopId: string | null;
      virtualTryOnState: string | null;
      voucherNewDesign: boolean | null;
      bazaarvoiceCookieConsentMapping: boolean | null;
      hasJsonLdOfferVoucherPrice: boolean | null;
      wishlistSsrEnabled: boolean | null;
      swogoIntegrationEnabled: boolean | null;
      recoProductDetailAddToCart: boolean | null;
      recoProductDetail: boolean | null;
      newNutritionAndVitaminsTable: boolean | null;
      swogoIgnoreConvertedPrice: boolean | null;
      pdHasAllReviewsPage: boolean | null;
      newBlogEndpoint: boolean | null;
      newDermoIcon: boolean | null;
      livestreamOnPdEnabled: boolean | null;
      pictogramsEnabled: boolean | null;
      bazaarvoiceIntegrationPd: {
        __typename: 'BazaarvoiceIntegrationType';
        environment: string;
        locale: string;
        siteId: string;
      } | null;
    };
  } | null;
  ProductSsrData: {
    __typename: 'ClientProductSsr';
    id: string | null;
    pathname: string | null;
    productId: string | null;
    type: string | null;
  } | null;
};

export type GetProductInfoQueryVariables = Exact<{
  masterId: Scalars['String'];
}>;

export type GetProductInfoQuery = {
  __typename?: 'Query';
  productDetailByMasterId: Array<{
    __typename?: 'Product';
    variants: Array<{
      __typename?: 'Variant';
      id: string | null;
      attributes: any | null;
      imagesByCategory: {
        __typename?: 'ImagesByCategory';
        mainImage: {
          __typename?: 'Image';
          alt: string | null;
          src: string | null;
        };
      } | null;
      seo: {
        __typename?: 'Seo';
        title: string | null;
        description: string | null;
        keywords: string | null;
      } | null;
      stockAvailability: {
        __typename?: 'StockInfo';
        count: number | null;
        code: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
  Settings: { __typename?: 'Settings'; imageDomainPath: string };
};
